import React, { useEffect, useState, useRef, forwardRef } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  IconButton,
  InputAdornment,
  Popover,
  Typography,
  Drawer,
  useMediaQuery,
} from "@mui/material";
import "../css/Contractor.css";
import { Box } from "@mui/material";
import Modal from "@mui/material/Modal";
import { IoIosClose, IoMdClose } from "react-icons/io";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import { BarLoader } from "react-spinners";
import { NumericFormat } from "react-number-format";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import Switch from "@mui/material/Switch";
import quantam from "./../image/favicon.png";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import PictureAsPdfRoundedIcon from "@mui/icons-material/PictureAsPdfRounded";
import { IoIosArrowRoundBack } from "react-icons/io";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import { Collapse } from "@mui/material";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";

const initialChange = {
  status: "",
};

const NumericFormatCustom = forwardRef(function NumericFormatCustom(
  props,
  ref
) {
  const { onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        if (Number(values.value) < 0) return;
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      valueIsNumericString
      style={{ padding: "6px" }}
      prefix="$"
      allowNegative={false}
    />
  );
});
function InspectorHome() {
  const navigate = useNavigate();
  const [selectedProject, setSelectedProject] = useState("");
  const [Changecontract, setChangeContract] = useState(false);
  const [milestoneList, setMilestoneList] = useState(null);
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [reuplodaselectedPdf, setReuploadSelectedPdf] = useState(null);
  const [loader, setLoader] = useState(false);
  const [ownerinformation, setownerInformation] = useState(false);
  const [changeRequest, setChangeRequest] = useState(initialChange);
  const [projectList, setProjectList] = useState([]);
  const [selectedOwner, setSelectedOwner] = useState({});
  const [milestoneListdata, setMilestoneListdata] = useState([]);
  const [projectname, setProjectname] = useState("");
  const [changeprojectname, setChangeProjectname] = useState("");
  const [projectid, setProjectid] = useState("");
  const [changeprojectid, setChangeProjectid] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [Notsigned, setNotSigned] = useState("");
  const [count, setCount] = useState({});
  const [ContractChangeRequest, setContractChangeRequest] = useState([]);
  const [genAI, setGenAI] = useState(false);
  const [error, setError] = useState("");
  const [state, setState] = useState({
    project_budget: "",
  });
  const [textAreaValues, setTextAreaValues] = useState([]);
  const [enableTextarea, setEnableTextarea] = useState(
    Array(ContractChangeRequest.length).fill(false)
  );
  const [editmilestone, setEditmilestone] = useState(false);
  const [Reuploadcontract, setReUplodacontract] = useState(false);
  const [filename, setFileName] = useState("");
  const [data, setData] = useState({});
  const [AImessage, setAImessage] = useState(false);
  const [inputList, setInputList] = useState([
    { Milestone: "", price: "", description: "" },
  ]);
  const [chatview, setChatView] = useState(false);
  const [messages, setMessages] = useState([]);
  const [sendcomment, setSendcomment] = useState("");
  const [disabled, setDisabled] = useState("");
  const [newMessage, setNewMessage] = useState("");
  const [milestonechangeRequestchat, setMilestonechangeRequestchat] = useState(
    []
  );
  const [milestoneStates, setMilestoneStates] = useState({});
  const [Nochat, setNoChat] = useState(false);
  const [values, setValues] = useState({
    numberformat: "",
  });
  const projectBudgetRef = useRef(null);
  const [shouldFocus, setShouldFocus] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [popupWindow, setPopupWindow] = useState(null);
  const [selectedPdfFile, setSelectedPdfFile] = useState(null);
  const [contractorInfo, setConTractorInfo] = useState(false);
  const [selectedContractor, setSelectedContractor] = useState({});
  const [openContract, setOpenContract] = useState(false);
  const [uploadInspectionDetails, setUploadInspectionDetails] = useState({
    name: "",
    doc: null,
    previewUrl: null, // Store the blob URL
  });
  const [mileChat, setMileChat] = useState(false);
  const [mileChatContract, setMileChatContract] = useState(false);
  const [milestoneChangeRequest, setMilestoneChangeRequest] = useState([]);
  const [viewInspectionReport, setViewInspectorReport] = useState(false);
  const [inspectionReport, setInspectionReport] = useState([]);
  const [chatWith, setChatWith] = useState("contractor");
  const [commentsModal, setCommentsModal] = useState(false);
  const [comments, setComments] = useState({
    positive: "",
    negative: "",
  });
  const [selectedMileStone, setSelectedMilestone] = useState(null);
  const complaintRef = useRef(null);
  const [isLoader, setIsLoader] = useState(false);
  const [milNum, setMilNum] = useState("");
  const [expanded, setExpanded] = useState({});
  const [expandInspection, setExpandInspection] = useState({});
  const [showDocuments, setShowDocuments] = useState(null);
  const [fileError, setFileError] = useState("");
  const [projectLoaderMsg, setProjectLoaderMsg] = useState(
    "Fetching records..."
  );
  const [viewCR, setViewCR] = useState(false);
  const [chatViewCR, setChatViewCR] = useState(false);
  const [viewInsHistory, setViewInsHistory] = useState(false);

  //File modal view
  const [selectedContractDoc, setSelectedContractDoc] = useState(null);
  const [ContractDocuments, setContractDocuments] = useState(false);

  const location = useLocation();
  const { notification } = location.state || {};
  const isMobile = useMediaQuery("(max-width:768px)");

  const toggleExpand = (msgIndex) => {
    setExpanded((prev) => ({
      ...prev,
      [msgIndex]: !prev[msgIndex],
    }));
  };

  const toggleExpandInspection = (msgIndex) => {
    setExpandInspection((prev) => ({
      ...prev,
      [msgIndex]: !prev[msgIndex],
    }));
  };

  const cookies = document.cookie.split("; ").reduce((acc, cookie) => {
    const [name, value] = cookie.split("=");
    acc[name] = decodeURIComponent(value);
    return acc;
  }, {});
  const headers = {
    "X-CSRFToken": cookies.csrftoken,
  };

  const [files, setFiles] = useState([]);
  useEffect(() => {
    setProjectLoaderMsg("Fetching records...");

    getProjectlist();
  }, []);

  useEffect(() => {
    if (shouldFocus && projectBudgetRef.current) {
      projectBudgetRef.current.focus();
      setShouldFocus(false);
    }
  }, [shouldFocus]);

  useEffect(() => {
    if (selectedMileStone) {
      setMessages([]);
      handlegetchat(selectedMileStone);
    }
  }, [chatWith]);

  useEffect(() => {
    if (data && data?.length === 0) {
      setInputList([
        { price: "", Milestone: "", description: "" },
        { price: "", Milestone: "", description: "" },
        { price: "", Milestone: "", description: "" },
      ]);
    } else if (data && data?.data && data?.data.length !== 0) {
      setInputList(
        data?.data?.map((item) => ({
          price: item.price,
          Milestone: item.milestone,
          description: item?.description,
        }))
      );
    }
  }, [data]);

  useEffect(() => {
    const fetchData = async () => {
      if (!notification) return; // Ensure notification exists before making the request

      const milestoneId = {
        project_id: notification?.project_id,
        milestone_id: notification?.milestone_id,
      };

      try {
        const response = await axios.post(
          "/cvault/milestone-details/",
          milestoneId,
          { headers }
        );

        const MileData = response?.data?.data?.filter(
          (item) => item.id === notification?.milestone_id
        );

        var data = await axios.get("/cvault/inspector-milestones/");
        const InspectorMileData = data?.data?.filter(
          (item) => item.id === notification?.milestone_id
        );

        // For chat view
        if (notification) {
          if (InspectorMileData[0].status === "Inspection Completed") {
            if (!notification?.chat_relation) {
              setMilNum(InspectorMileData?.[0]?.milestone_number);
              setMileChat(true);
              setSelectedMilestone(MileData?.[0]);
              setChangeProjectname(notification?.project_name);
              setChangeProjectid(notification?.project_id);
              getPdf(MileData?.[0]?.project);
              setFiles([]);
              setMessages([]);
              handlegetchat(MileData?.[0], notification?.project_id);
              setSelectedOwner(InspectorMileData?.[0]);
              setMilestoneChangeRequest(MileData);
              // setChatWith(notification?.chat_relation);
              setChatWith(
                InspectorMileData[0]?.inspector_chart_relationship
                  ?.toLowerCase()
                  .includes("owner")
                  ? "owner"
                  : "contractor"
              );
            } else {
              setMilNum(InspectorMileData?.[0]?.milestone_number);
              setMileChat(true);
              setSelectedMilestone(MileData?.[0]);
              setChangeProjectname(notification?.project_name);
              setChangeProjectid(notification?.project_id);
              getPdf(MileData?.[0]?.project);
              setFiles([]);
              setMessages([]);

              handlegetchat(MileData?.[0], notification?.project_id);
              setSelectedOwner(InspectorMileData?.[0]);
              setMilestoneChangeRequest(MileData);

              setChatWith(
                InspectorMileData[0]?.inspector_chart_relationship
                  ?.toLowerCase()
                  .includes("owner")
                  ? "owner"
                  : "contractor"
              );
            }
          } else if (InspectorMileData[0].status === "Inspection Initiated") {
            if (!notification?.chat_relation) {
              setChangeContract(true);
              MilestonechangeRequest(
                notification?.project_id,
                notification?.milestone_id
              );
              setChangeProjectname(notification?.project_name);
              setChangeProjectid(notification?.project_id);
              getPdf(notification?.project_id);
              setSelectedMilestone(MileData?.[0]);
              setFiles([]);
              setMilNum(InspectorMileData?.[0]?.milestone_number);
              setChatWith(
                notification?.chat_relation?.toLowerCase().includes("Owner")
                  ? "owner"
                  : "contractor"
              );
            } else {
              setMilNum(InspectorMileData?.[0]?.milestone_number);
              setMileChat(true);
              setSelectedMilestone(MileData?.[0]);
              setChangeProjectname(notification?.project_name);
              setChangeProjectid(notification?.project_id);
              getPdf(MileData?.[0]?.project);
              setFiles([]);
              setMessages([]);

              handlegetchat(MileData?.[0], notification?.project_id);
              setSelectedOwner(InspectorMileData?.[0]);
              setMilestoneChangeRequest(MileData);
              setChatWith(
                notification?.chat_relation?.toLowerCase().includes("Owner")
                  ? "owner"
                  : "contractor"
              );
            }
          }
          //for view report --- completed
          else {
            setMilNum(InspectorMileData?.[0]?.milestone_number);
            setSelectedMilestone(MileData?.[0]);
            viewReports(notification?.milestone_id);
          }
        }
        navigate(location.pathname, { replace: true, state: null });
      } catch (error) {}
    };

    fetchData(); // Ensure the function is called when notification changes
  }, [notification]); // Add missing dependencies

  const handleInspectorFileChange = (e) => {
    setFileError("");
    //Limit total file size within 200MB
    const selectedFiles = Array.from(e.target.files);
    const maxTotalSize = 200 * 1024 * 1024;

    let currentTotalSize = files.reduce((acc, file) => acc + file.file.size, 0);
    let validFiles = [];

    for (let file of selectedFiles) {
      if (files.some((f) => f.name === file.name)) {
        // toast.warning(`File ${file.name} is already included.`);
        setFileError(`File ${file.name} is already included.`);
        continue;
      }

      if (currentTotalSize + file.size > maxTotalSize) {
        toast.warning(
          `Adding ${file.name} exceeds the maximum total file size limit of 200MB.`
        );
        break;
      }
      validFiles.push(file);
      currentTotalSize += file.size;
    }

    const newFiles = validFiles.map((file) => ({
      file,
      name: file.name,
      blob: new Blob([file], { type: file.type }),
      type: file.type.startsWith("image")
        ? "image"
        : file.type.startsWith("video")
        ? "video"
        : file.type === "application/pdf"
        ? "pdf"
        : "other",
      originalFile: file,
    }));

    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    e.target.value = "";
  };

  const handleDelete = (index) => {
    setFileError("");
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const modelStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    borderRadius: "5px",
    boxShadow: 24,
    maxHeight: "90vh", // Ensure it does not exceed viewport height
    overflowY: "auto",
    width: "80%",
    margin: "auto",
  };

  const iframeStyle = {
    width: "100%",
    height: "-webkit-fill-available",
    border: "none",
  };

  const modelStyleowner = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    borderRadius: "5px",
    boxShadow: 24,
    p: 2,
    width: "50%",
    maxHeight: "90vh", // Ensure it does not exceed viewport height
    overflowY: "auto",
  };

  const Reupload = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    borderRadius: "5px",
    boxShadow: 24,
    p: 2,
    width: "80%",
    margin: "auto",
    maxHeight: "90vh", // Ensure it does not exceed viewport height
    overflowY: "auto",
  };

  var popoverStyle = {
    border: " 0px solid rgba(0, 0, 0, .2)",
    borderRadius: "2px",
    fontFamily: "Roboto,sans-serif",
    boxShadow: " 0 2px 10px rgba(0, 0, 0, .2)",
    padding: "5px 15px 10px 15px",
    lineHeight: " 24px",
    fontSize: "14px",
    width: "200px",
    height: "23vh",
    background: "white",
  };

  const getProjectlist = async () => {
    setProjectLoaderMsg("Fetching records...");

    try {
      var data = await axios.get("/cvault/inspector-milestones/");

      const cdata = data?.data.map((project, index) => {
        return { ...project, id: index + 1, milestone_id: project.id };
      });

      setProjectList(cdata);
      setTimeout(() => {
        setProjectLoaderMsg("No inspection requests found");
      }, 100);
    } catch (error) {
      setProjectLoaderMsg("No inspection requests found");

      toast.error("Unable to fetch inspection details. Please try again later");
    }
  };

  const acceptInspection = async (row) => {
    const userData = JSON.parse(localStorage.getItem("userData"));

    const data = {
      project: row?.project,
      milestone: row?.milestone_id,
      inspection: userData?.user_id,
    };
    setLoader(true);

    try {
      const data = {
        project_id: row?.project,
        milestone_id: row?.milestone_id,
        inspection_id: userData?.user_id,
      };
      const response = await axios.post("/cvault/inspector-acceptance/", data, {
        headers: headers,
      });

      setLoader(false);
      toast.success(
        `Inspection Accepted for Milestone(${row?.milestone_number || 1})`
      );
      getProjectlist();
    } catch (error) {
      setLoader(false);
      getProjectlist();
      toast.error("Unable to Accept the inspection. Please try again later");
    }
  };

  const controllerRef = useRef(null); // Store AbortController instance

  const viewFiles = async (file, iframeShow = false) => {
    setFileError("");

    iframeShow && setShowDocuments(null);

    iframeShow ? setIsLoader(true) : setLoader(true);

    if (controllerRef.current) {
      controllerRef.current.abort();
    }

    // Create a new AbortController for the new request
    controllerRef.current = new AbortController();
    const signal = controllerRef.current.signal;

    try {
      const response = await axios.get(`cvault/file-view/?file_path=${file}`, {
        signal,
      });

      setLoader(false);
      setIsLoader(false);
      const downfunc = (response) => {
        let fileName = response?.data?.file_name;
        let base64Content = response?.data?.base64_content.trim();
        // Automatically download unsupported file types
        if (base64Content.includes(",")) {
          base64Content = base64Content.split(",")[1];
        }

        try {
          // ✅ Ensure Base64 string length is a multiple of 4
          while (base64Content.length % 4 !== 0) {
            base64Content += "=";
          }

          // ✅ Decode Base64 content
          const byteCharacters = atob(base64Content);
          const byteNumbers = new Uint8Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const blob = new Blob([byteNumbers], {
            type: response?.data?.mimeType,
          });

          // ✅ Create a Blob URL and trigger the download
          const blobUrl = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = blobUrl;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          // ✅ Free memory
          URL.revokeObjectURL(blobUrl);
          setShowDocuments(null);
        } catch (error) {
          console.error("Invalid Base64 content:", error);
        }
      };
      if (response?.data?.result && response?.data?.base64_content) {
        if (iframeShow) {
          if (
            /\.(jpg|jpeg|png|gif|bmp|webp|svg|tiff|ico|pdf|mp4|mov|wmv|avi|flv|mkv|webm|mpeg|mpg)$/i.test(
              response.data.file_name
            )
          ) {
            setShowDocuments(response?.data);
          } else {
            downfunc(response);
          }
        } else {
          setFileError("");
          if (
            /\.(jpg|jpeg|png|gif|bmp|webp|svg|tiff|ico|pdf|mp4|mov|wmv|avi|flv|mkv|webm|mpeg|mpg)$/i.test(
              response?.data?.file_name
            )
          ) {
            setContractDocuments(true);
            setSelectedContractDoc(response.data.base64_content);
          } else {
            downfunc(response);
          }
        }
      }
    } catch (error) {
      if (axios.isCancel(error)) {
        setIsLoader(true);
        setLoader(false);
        setFileError("");
      } else {
        setLoader(false);
        setIsLoader(false);
        iframeShow &&
          setFileError(
            error?.response?.data?.error || "File not found in cloud storage"
          );
        !iframeShow &&
          toast.error(
            error?.response?.data?.error || "File not found in cloud storage"
          );
      }
    }
  };

  const viewReports = async (id) => {
    setLoader(true);
    try {
      var datas = await axios.get(
        `/cvault/inspection-report-submit/?milestone_id=${id}`
      );
      setFiles(datas?.data?.file_data);
      setInspectionReport(datas?.data);
      setViewInspectorReport(true);
      setLoader(false);
    } catch (error) {
      setLoader(false);
    }
  };

  const getPdf = async (id) => {
    try {
      const data = {
        project: id,
      };
      const response = await axios.post("/cvault/get-pdf/", data, {
        headers: headers,
      });

      setSelectedPdfFile(response?.data?.base64_content);
    } catch (error) {
      setSelectedPdfFile(null);
    }
  };

  const columns = [
    { field: "id", headerName: "S.No", flex: 1, minWidth: 10 },
    {
      headerName: "Project Name",
      field: "project_name",
      sortable: false,
      flex: 2,
      minWidth: 150,
      renderCell: (params) => <div>{params?.row?.project_name}</div>,
    },
    {
      field: "requested_date",
      headerName: "Requested Date",
      flex: 2,
      minWidth: 100,
      maxWidth: 120,
      renderCell: (params) => <div>{formatDate(params?.row?.updated_at)}</div>,
    },
    {
      field: "mile_stone",
      headerName: "Milestone Name",
      flex: 2,
      minWidth: 100,
      renderCell: (params) => <div>{params?.row?.milestone}</div>,
    },
    {
      field: "owner_name",
      headerName: "Owner",
      flex: 2,
      minWidth: 100,
      renderCell: (params) => (
        <div
          className="MuiDataGrid-cellContent text-decoration-underline pointer"
          onClick={() => {
            ownerinfo(params?.row);
          }}
        >
          {params?.row?.owner_details?.owner_name}
        </div>
      ),
    },
    {
      field: "contractor_name",
      headerName: "Contractor",
      flex: 2,
      minWidth: 100,
      renderCell: (params) => (
        <div
          className="MuiDataGrid-cellContent text-decoration-underline pointer"
          onClick={() => {
            contractorinfoClick(params?.row);
          }}
        >
          {params?.row?.contractor_details?.contractor_name}
        </div>
      ),
    },
    {
      field: "inspection",
      headerName: "Milestone Status",
      sortable: false,
      flex: 2,
      minWidth: 195,

      renderCell: (params) =>
        params?.row?.status === "Inspection Assigned" ? (
          // <button
          //   className="btn detail-btn"
          //   onClick={() => {
          //     acceptInspection(params?.row);
          //   }}
          // >
          <div style={{ width: "100%" }}>Awaiting Acceptance</div>
        ) : // </button>
        params?.row?.status === "Inspection Initiated" ? (
          // <button
          //   className="btn detail-btn"
          //   onClick={() => {
          //     // setChangeRequest(initialChange);

          // setChangeContract(true);
          // MilestonechangeRequest(
          //   params?.row?.project,
          //   params?.row.milestone_id
          // );
          // setChangeProjectname(params?.row?.project_name);
          // setChangeProjectid(params?.row?.project);
          // getPdf(params?.row?.project);
          // setSelectedMilestone(params);
          // setFiles([]);
          // setMilNum(params?.row?.milestone_number);
          //   }}
          //   style={{ boxShadow: "0px 0px 0.5px 0.5px lightgray" }}
          // >
          //   Inspection In Progress
          // </button>
          <select
            className="select-form-control form-control"
            value={params?.row?.status}
            style={{ width: "100%", fontSize: "14px" }}
            onChange={(e) => {
              setChangeContract(true);
              MilestonechangeRequest(
                params?.row?.project,
                params?.row.milestone_id
              );
              setChangeProjectname(params?.row?.project_name);
              setChangeProjectid(params?.row?.project);
              getPdf(params?.row?.project);
              setSelectedMilestone(params);
              setFiles([]);
              setMilNum(params?.row?.milestone_number);
            }}
            disabled={loader}
          >
            {params?.row?.status === "Inspection Initiated" && (
              <option value="Inspection Initiated" disabled>
                Inspection In Progress
              </option>
            )}
            <option value="Submit Report">Submit Report</option>
          </select>
        ) : params?.row?.status === "Hold" ? (
          <div style={{ width: "100%" }}>Admin Review</div>
        ) : params?.row?.status === "Completed" ? (
          <div style={{ width: "100%" }}>Closed</div>
        ) : (
          <button
            className="btn detail-btn"
            onClick={() => {
              setMilNum(params?.row?.milestone_number);
              setSelectedMilestone(params);

              viewReports(params?.row?.milestone_id);
            }}
            style={{ boxShadow: "0px 0px 0.5px 0.5px lightgray" }}
          >
            {/* {params?.row?.status} */}
            View Report
          </button>
        ),
    },
    {
      field: "Awaiting",
      headerName: "Acceptance Status",
      sortable: false,
      flex: 2,
      minWidth: 100,

      renderCell: (params) =>
        params?.row?.status === "Inspection Assigned" ? (
          <button
            className="btn btn-cvault"
            onClick={() => {
              acceptInspection(params?.row);
            }}
            style={{
              fontSize: "14px",
              fontWeight: 400,
              boxShadow: "gray 0px 0px 0.5px 0.5px",
            }}
          >
            Accept
          </button>
        ) : (
          <div style={{ width: "100%", marginLeft: "10px" }}>Accepted</div>
        ),
    },
    {
      field: "chat",
      headerName: "Chat Room",
      sortable: false,
      flex: 1,
      minWidth: 100,

      renderCell: (params) => (
        <button
          className="btn detail-btn"
          style={{ background: "transparent" }}
          onClick={() => {
            // setChangeRequest(initialChange);
            // setChangeContract(true);
            setMilNum(params?.row?.milestone_number);
            setMileChat(true);

            MilestonechangeRequest(
              params?.row?.project,
              params?.row.milestone_id,
              true
            );
            setSelectedMilestone(params);

            setChangeProjectname(params?.row?.project_name);
            setChangeProjectid(params?.row?.project);
            getPdf(params?.row?.project);
            setFiles([]);
            setMessages([]);

            handlegetchat(params);
            setSelectedOwner(params?.row);
            setChatWith(
              params?.row?.inspector_chart_relationship
                .toLowerCase()
                .includes("owner")
                ? "owner"
                : "contractor"
            );
          }}
          disabled={
            params?.row?.status === "Completed" ||
            params?.row?.status === "Inspection Assigned" ||
            params?.row?.status === "Hold" ||
            params?.row?.status === "In Progress" ||
            params?.row?.status === "Inspection Request" ||
            params?.row?.status === "Inspection Accepted" ||
            params?.row?.status === "Contractor Payment Initiated" ||
            params?.row?.status === "Contractor Payment Awaiting"
          }
        >
          <QuestionAnswerIcon style={{ color: "#F5AE41" }} />
        </button>
      ),
    },
  ];

  const headerClassName = "custom-header";

  const renderHeader = (params) => {
    return <div className={headerClassName}>{params.colDef.headerName}</div>;
  };
  const changeRequestData = ContractChangeRequest.map((milestone, index) => ({
    milestone: milestone.id,
    milestone_name: milestone.milestone,
    description: milestone.milestone_description,
    price: milestone.milestone_amount,
    milestone_number: milestone.milestone_number,
    comment: textAreaValues[index] || "",
  }));

  const MilestonechangeRequest = async (
    id,
    mileId = null,
    isMileChat = false
  ) => {
    setLoader(true);
    try {
      const milestoneId = {
        project_id: id,
      };
      if (mileId !== null) {
        milestoneId.milestone_id = mileId;
      }
      const response = await axios.post(
        "/cvault/milestone-details/",
        milestoneId,
        {
          headers: headers,
        }
      );
      const pData = response?.data?.data;

      setLoader(false);
      setDisabled(response?.data?.status);
      if (!isMileChat) {
        setContractChangeRequest(pData);
      } else {
        setMilestoneChangeRequest(pData);
      }
    } catch (error) {
      setLoader(false);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "phone") {
      if (value.length <= 10) {
        setState((prev) => ({ ...prev, [name]: value }));
      }
    } else if (name === "zip") {
      if (value.length <= 5) {
        setState((prev) => ({ ...prev, [name]: value }));
      }
    } else {
      const sanitizedValue =
        name === "month" || name === "date"
          ? Math.max(0, parseInt(value, 10))
          : value;
      setState((prev) => ({ ...prev, [name]: sanitizedValue }));
    }
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    setSelectedPdf(file);
    setFileName(file?.name);
    milestonepdfs(file);
    setAImessage(true);
    milestonepdf(file);
  };

  const milestonepdf = async (file) => {
    setLoader(true);
    if (genAI) {
      try {
        const formData = new FormData();
        formData.set("pdf", file);

        const response = await axios.post(
          "/cvault/pdf-milestone-parser/",
          formData,
          {
            headers: headers,
          }
        );
        setData(response.data);
        setLoader(false);
      } catch (error) {
        setInputList([
          { price: "", Milestone: "" },
          { price: "", Milestone: "" },
          { price: "", Milestone: "" },
        ]);
        setLoader(false);
      }
    } else {
      setLoader(false);
      setInputList([
        { Milestone: "", price: "", description: "" },
        { Milestone: "", price: "", description: "" },
        { Milestone: "", price: "", description: "" },
      ]);
      toast.warning(
        "Uploaded Contract opened in Viewer. Please update all the required Milestone details manually"
      );
    }
  };

  const handleToggle = (event, newChatWith) => {
    if (newChatWith !== null) {
      setNewMessage("");
      setMessages([]);

      setChatWith(newChatWith);
    }
  };

  const getGenAI = async () => {
    try {
      var pData = await axios.get("/cvault/genai-status/");
      setGenAI(pData?.data?.genai_status);
    } catch (error) {
      toast.error("Please try again later");
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const ownerinfo = (row) => {
    setSelectedOwner(row);
    setownerInformation(true);
  };

  const contractorinfoClick = (row) => {
    setSelectedContractor(row);
    setConTractorInfo(true);
  };

  const handleMilestoneModal = async (id) => {
    setProjectid(id);
    try {
      const milestonedata = await axios.get(
        `/cvault/get-milestones/?project_id=${id}`
      );
      setMilestoneListdata(milestonedata?.data?.data);
      setNotSigned(milestonedata?.data?.project_status);
      getProjectlist();
    } catch (error) {}
  };

  const handlegetchat = async (milestone, prj = null) => {
    setMilestonechangeRequestchat(milestone);
    setMessages([]);
    setNewMessage("");
    setSendcomment("");
    setNoChat(false);
    const data = {
      project_id: prj || milestone?.row?.project || changeprojectid,
      milestone_id: milestone?.id,
      chat_relation:
        chatWith === "owner" ? "Inspector-Owner" : "Contractor-Inspector",
    };

    try {
      const response = await axios.post(
        "/cvault/inspection-history-chats/",
        data,
        {
          headers: headers,
        }
      );
      if (
        Array.isArray(response?.data?.data) &&
        response?.data?.data?.length === 0
      ) {
        setSendcomment(response?.data.status);
        setNoChat(true);
      } else {
        setSendcomment(response?.data.status);
        setMessages(response?.data?.data);
      }
      window.scrollTo(0, document.body.scrollHeight);

      // setMessages(response?.data?.data);
      // setChatView(true);
    } catch (error) {
      toast.error("Unable to retrieve chat details. Please try again later.");
    }
  };

  const handleSendMessage = async () => {
    if (newMessage.trim() === "") {
      return;
    }
    setMessages([...messages, { chat: newMessage, user: "Inspector" }]);
    setNoChat(false);
    setNewMessage("");
  };

  const mileStonechangeRequestData = milestoneChangeRequest.map(
    (milestone, index) => ({
      milestone: milestone.id,
      milestone_name: milestone.milestone,
      description: milestone.milestone_description,
      price: milestone.milestone_amount,
      milestone_number: milestone.milestone_number,
      comment: textAreaValues[index] || newMessage,
      chat_relation:
        chatWith === "owner" ? "Inspector-Owner" : "Contractor-Inspector",
    })
  );

  const sendchat = async () => {
    setLoader(true);
    if (newMessage?.length > 0) {
      const data = {
        chatData: mileStonechangeRequestData[0],
        project: changeprojectid,
      };
      try {
        const response = await axios.post("/cvault/inspection-chat/", data, {
          headers: headers,
        });
        setSendcomment(true);
        MilestonechangeRequest(
          changeprojectid,
          mileStonechangeRequestData[0].id
        );
        setLoader(false);
      } catch (error) {
        setLoader(false);
      }
    }
  };

  const Reuploadfeedback = async () => {
    setEditmilestone(false);
    try {
      const data = {
        changeRequestData,
        project: changeprojectid,
      };
      setChangeContract(false);
      setLoader(true);
      const response = await axios.post(
        "/cvault/project-change-request/",
        data,
        {
          headers: headers,
        }
      );
      setLoader(false);
      toast.success("Change request sent to Owner for approval");
      getProjectlist();
      setSelectedPdf(null);
      setChangeProjectid("");
      setTextAreaValues([]);
      setEnableTextarea(Array(ContractChangeRequest.length).fill(false));
    } catch (error) {
      setLoader(false);
      setChangeProjectid("");
      setChangeContract(false);
      setTextAreaValues([]);
      setEnableTextarea(Array(ContractChangeRequest.length).fill(false));
      setSelectedPdf(null);
      toast.error("Please try again later.");
    }
  };

  const handleMilestone = (id, name, row) => {
    setProjectname(name);
    handleMilestoneModal(id);
    setMilestoneList(id);
  };

  const handleInputChange = (e, index, field) => {
    const updatedContractChangeRequest = [...ContractChangeRequest];
    updatedContractChangeRequest[index][field] = e.target.value;
    setContractChangeRequest(updatedContractChangeRequest);
  };

  const milestonepdfs = (file) => {
    const pdfUrl = URL.createObjectURL(file);
    setReuploadSelectedPdf(pdfUrl);
  };

  const handleInputChanges = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList];
    list[index][name] = value;
    setInputList(list);
  };

  const handleRemoveClick = (index) => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
  };

  const handleAddClick = () => {
    setInputList([...inputList, { price: "", Milestone: "" }]);
  };

  const Acceptproject = async () => {
    if (selectedPdf !== null) {
      if (state.project_budget !== "") {
        setAImessage(false);
        try {
          setChangeContract(false);
          const formData = new FormData();
          formData.set("budget", state.project_budget);
          formData.set("milestone_details", JSON.stringify(inputList));
          formData.set("project_id", changeprojectid);
          if (selectedPdf) {
            formData.set("pdf_path", selectedPdf);
          }
          setLoader(true);
          const response = await axios.post(
            "/cvault/contract-reupload/",
            formData,
            {
              headers: headers,
            }
          );
          setReUplodacontract(false);
          setLoader(false);
          setChangeProjectid("");
          setReuploadSelectedPdf(null);
          setState({
            project_budget: "",
          });
          toast.success("Change request sent to Owner for approval");
          getProjectlist();
          setSelectedPdf(null);
          setChangeProjectid("");
          setTextAreaValues([]);
          setEnableTextarea(Array(ContractChangeRequest.length).fill(false));
        } catch (error) {
          setLoader(false);
          setReuploadSelectedPdf(null);
          setReUplodacontract(false);
          setChangeProjectid("");
          setChangeContract(false);
          setState({
            project_budget: "",
          });
          setTextAreaValues([]);
          setEnableTextarea(Array(ContractChangeRequest.length).fill(false));
          setSelectedPdf(null);
          toast.error("Please try again later.");
        }
      } else {
        toast.error("Please enter Project budget");
        setShouldFocus(true);
      }
    } else {
      toast.error("Please Upload Contract pdf");
    }
  };

  const genAIChange = async (event) => {
    setGenAI(event.target.checked);
  };

  const openPopupWindow = () => {
    if (popupWindow && !popupWindow.closed) {
      popupWindow.focus();
      popupWindow.location.href = "http://localhost:4200/";
    } else {
      const newWindow = window.open("http://localhost:4200/", "tab");
      setPopupWindow(newWindow);
    }
  };

  const formatDate = (isoString) => {
    const date = new Date(isoString);
    const options = { year: "numeric", month: "short", day: "numeric" };

    return date.toLocaleDateString("en-US", options);
  };

  const convertBlobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const submitReport = async (status) => {
    const formData = new FormData();

    // Append milestone ID
    formData.append("milestone_id", ContractChangeRequest[0]?.id);

    // Append comments
    formData.append("compliance_comments", comments.negative);
    formData.append("non_compliance_comments", comments.positive);

    // Append files

    if (files.length > 0) {
      files.forEach((file) => {
        formData.append("files", file.file);
      });
    }

    // Append other data
    const userData = JSON.parse(localStorage.getItem("userData"));
    formData.append("inspection_status", "Inspection Completed");
    formData.append("inspector_name", userData?.user_id);
    formData.append("project", changeprojectid);
    formData.append("compliance_status", status);

    try {
      const response = await axios.post(
        "/cvault/inspection-report-submit/",
        formData,
        {
          headers: {
            ...headers,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setComments({ positive: "", negative: "" });
      setFiles([]);
      setProjectList([]);
      getProjectlist();
      setLoader(false);
      setCommentsModal(false);
      setChatView(false);
      setChangeContract(false);

      toast.success(
        `Inspection Report submitted for Milestone(${
          selectedMileStone?.row?.milestone_number || 1
        })`
      );
    } catch (error) {
      setLoader(false);
      if (
        error.response?.data?.error.toLowerCase().includes("already exists")
      ) {
        toast.error("File already exists");
      } else toast.error("Something went wrong");
    }
  };

  return (
    <div className="mt-2 p-4">
      <div className={`app-container ${loader ? "loader-container" : ""}`}>
        {loader && (
          <div className="loader-overlay">
            <BarLoader
              color="#F5AE41"
              width={400}
              height={10}
              className="loader"
              loading={loader}
            />
          </div>
        )}
      </div>
      <div className="d-flex justify-content-between mx-1 mb-3">
        <div>
          <h4 className="fw-bold">Project List - Inspector View</h4>
        </div>
      </div>
      <div className="card card-cvault">
        <div className="card-body" style={{ width: "100%" }}>
          <DataGrid
            rows={projectList}
            columns={columns.map((column) => ({
              ...column,
              headerClassName,
              renderHeader,
            }))}
            getRowId={(row) => row.milestone_id}
            autoHeight
            initialState={{
              pagination: {
                paginationModel: { pageSize: 10, page: 0 },
              },
            }}
            pageSizeOptions={[10, 25, 50]}
            hideFooterSelectedRowCount
            localeText={{ noRowsLabel: projectLoaderMsg }}
          />
        </div>
      </div>
      <div>
        {" "}
        {/* <a href="http://localhost:4200/" className="quantam" target="tab1">
          <img src={quantam} alt="quantam" className="deck" />
          <span className="text text-dark">Quantam Deck</span>
        </a> */}
        {/* <button className="quantam" onClick={openPopupWindow}>
          <img src={quantam} alt="quantam" className="icon" />
          <span className="text">Quantam Deck</span>
        </button> */}
      </div>

      {mileChat && (
        <div
          className="card card-cvault mt-4 ps-3 pt-3 pe-3"
          id="expandOfProjects"
        >
          <div>
            <div
              style={{
                position: "sticky",
                top: "0",
                backgroundColor: "white",
                zIndex: 1,
                padding: "0px 10px 10px 10px",
                borderBottom: "1px solid lightgray",
              }}
              className="d-flex align-items-center justify-content-between"
            >
              <div>
                <h5>
                  <span className="">Project</span>
                  <span> : </span>{" "}
                  <span className="projectname"> {changeprojectname}</span>
                </h5>
              </div>

              <div className="d-flex align-items-center">
                <button
                  onClick={() => {
                    setChangeContract(false);
                    setMilestoneChangeRequest([]);
                    setMileChat(false);
                    setMileChatContract(false);
                    setChatViewCR(false);
                    setViewInsHistory(false);
                    setExpanded({});
                    setExpandInspection({});
                  }}
                  className="btn detail-btn"
                >
                  Close
                </button>
              </div>
            </div>
            <div>
              <div className="d-flex  row m-auto custom-row">
                <div
                  className={"col-md-6 pt-4"}
                  style={{
                    borderRight: "1px solid lightgray",
                    height: "520px",
                    overflowY: "auto",
                  }}
                >
                  {milestoneChangeRequest.map((milestone, index) => (
                    <div
                      key={index}
                      className="row custom-row"
                      style={{ margin: "0px !important" }}
                    >
                      <div className={"col-md-12"}>
                        <div>
                          <span
                            className="d-flex justify-content-end"
                            style={{
                              width: isMobile ? "88%" : "47%",
                              position: "absolute",
                            }}
                          >
                            <Tooltip
                              title={
                                !mileChatContract
                                  ? "Click to view contract"
                                  : "Click to close contract"
                              }
                              placement="left"
                            >
                              {selectedPdfFile && (
                                <div
                                  className="cursor"
                                  onClick={() => {
                                    setMileChatContract(!mileChatContract);
                                  }}
                                >
                                  {!mileChatContract ? (
                                    <PictureAsPdfRoundedIcon className="text-primary" />
                                  ) : (
                                    <svg
                                      class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium text-primary css-i4bv87-MuiSvgIcon-root"
                                      focusable="false"
                                      aria-hidden="true"
                                      viewBox="0 0 24 24"
                                      data-testid="PictureAsPdfRoundedIcon"
                                      fill="#0d6efd"
                                      width={"24"}
                                      height={"24"}
                                    >
                                      <path d="M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v1.25c0 .41-.34.75-.75.75s-.75-.34-.75-.75V8c0-.55.45-1 1-1H10c.83 0 1.5.67 1.5 1.5zm5 2c0 .83-.67 1.5-1.5 1.5h-2c-.28 0-.5-.22-.5-.5v-5c0-.28.22-.5.5-.5h2c.83 0 1.5.67 1.5 1.5zm4-3.75c0 .41-.34.75-.75.75H19v1h.75c.41 0 .75.34.75.75s-.34.75-.75.75H19v1.25c0 .41-.34.75-.75.75s-.75-.34-.75-.75V8c0-.55.45-1 1-1h1.25c.41 0 .75.34.75.75M9 9.5h1v-1H9zM3 6c-.55 0-1 .45-1 1v13c0 1.1.9 2 2 2h13c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1-.45-1-1V7c0-.55-.45-1-1-1m11 5.5h1v-3h-1z"></path>

                                      <path
                                        d="M4 4L20 20"
                                        stroke="gray"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                      />
                                      <path
                                        d="M4 20L20 4"
                                        stroke="gray"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                      />
                                    </svg>
                                  )}
                                </div>
                              )}
                            </Tooltip>
                          </span>
                          <div className="d-flex flex-column">
                            <div className="mb-2">
                              <label
                                className="milestonechangeRequest"
                                style={{ width: "28%" }}
                              >
                                Milestone
                              </label>
                              {" : "}
                              <span className="text-center text-primary">
                                {milNum + ". " + milestone?.milestone}
                              </span>
                            </div>
                            <div className="flex-grow-1 d-flex flex-column">
                              <label className="milestonechangeRequest">
                                Milestone Description
                              </label>

                              <div
                                style={{
                                  marginTop: "10px",
                                  overflowX: "hidden",
                                  whiteSpace: "pre-wrap",
                                  wordBreak: "break-word",
                                  height: "auto",
                                  marginBottom: "0px",
                                }}
                              >
                                <div>{milestone.milestone_description}</div>

                                {milestone?.change_request?.length > 0 && (
                                  <div
                                    onClick={() => {
                                      setChatViewCR(!chatViewCR);
                                    }}
                                    style={{ cursor: "pointer" }}
                                    className="d-flex align-items-center mt-1"
                                  >
                                    <span
                                      style={{
                                        transition: "transform 0.3s ease",
                                        fontSize: "10px",
                                      }}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        version="1.1"
                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                        viewBox="0 0 512 512"
                                        width={15}
                                        height={15}
                                        style={{
                                          enableBackground: "new 0 0 512 512",
                                        }}
                                        xmlSpace="preserve"
                                      >
                                        <g>
                                          <path
                                            d="M420.608 311.463 512 259l-96.612-55.463L512 148.073 256 1.109 0 148.073l96.612 55.463L0 259l91.39 52.463L0 363.927 256 510.89l256-146.963-91.392-52.464zM80.29 148.073 256 47.201l175.71 100.871L256 248.943 80.29 148.073zm0 110.925 56.468-32.417L256 295.035l119.242-68.454 56.468 32.417L256 359.868 80.29 258.998zm0 104.929 51.246-29.419L256 405.96l124.464-71.452 51.246 29.419L256 464.798 80.29 363.927z"
                                            fill={"#000"}
                                          />
                                        </g>
                                      </svg>
                                    </span>
                                    <span
                                      className="ms-2 text-primary"
                                      style={{
                                        color: !chatViewCR
                                          ? "#0d6efd"
                                          : "lightgray",
                                      }}
                                    >
                                      {!chatViewCR
                                        ? "View Change Request History"
                                        : "Close Change Request History"}
                                    </span>
                                  </div>
                                )}
                                {chatViewCR && (
                                  <div
                                    style={{
                                      borderLeft: "2px solid lightgray",
                                      marginLeft: "7px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        marginLeft: chatViewCR ? "25px" : "0px",
                                      }}
                                    >
                                      {milestone?.change_request?.length > 0 &&
                                        milestone?.change_request.map(
                                          (request, index) => (
                                            <div
                                              key={index}
                                              style={{
                                                marginTop: "5px",
                                              }}
                                            >
                                              <strong>
                                                {
                                                  request?.change_request_heading
                                                }
                                                {":"}
                                              </strong>
                                              <div>
                                                {"Initiated Date: " +
                                                  request.initiate_date}
                                              </div>
                                              <div>
                                                {
                                                  request
                                                    ?.change_request_description?.[0]
                                                    ?.user_name
                                                }{" "}
                                                (
                                                {
                                                  request
                                                    ?.change_request_description?.[0]
                                                    ?.user_role
                                                }
                                                ) initiated a change request
                                              </div>
                                              {request?.change_request_description?.map(
                                                (msg, msgIndex) => (
                                                  <div>
                                                    <div key={msgIndex}>
                                                      <span>
                                                        {msg?.user_name} (
                                                        {msg?.user_role}):{" "}
                                                        {msg?.message}
                                                      </span>

                                                      {msg?.files_path?.length >
                                                        0 && (
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            alignItems:
                                                              "center",
                                                          }}
                                                        >
                                                          <Tooltip
                                                            title={
                                                              !expanded[
                                                                msgIndex
                                                              ]
                                                                ? "Click to expand files"
                                                                : "Click to collpase files"
                                                            }
                                                            placement="right"
                                                          >
                                                            <div
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                              }}
                                                              className="d-flex align-items-center"
                                                              onClick={() =>
                                                                toggleExpand(
                                                                  msgIndex
                                                                )
                                                              }
                                                            >
                                                              <span
                                                                style={{
                                                                  transition:
                                                                    "transform 0.3s ease",

                                                                  fontSize:
                                                                    "10px",
                                                                }}
                                                              >
                                                                <svg
                                                                  xmlns="http://www.w3.org/2000/svg"
                                                                  version="1.1"
                                                                  xmlnsXlink="http://www.w3.org/1999/xlink"
                                                                  viewBox="0 0 512 512"
                                                                  width={15}
                                                                  height={15}
                                                                  style={{
                                                                    marginBottom:
                                                                      "4px",
                                                                    enableBackground:
                                                                      "new 0 0 512 512",
                                                                  }}
                                                                  xmlSpace="preserve"
                                                                >
                                                                  <g>
                                                                    <path
                                                                      d="M420.608 311.463 512 259l-96.612-55.463L512 148.073 256 1.109 0 148.073l96.612 55.463L0 259l91.39 52.463L0 363.927 256 510.89l256-146.963-91.392-52.464zM80.29 148.073 256 47.201l175.71 100.871L256 248.943 80.29 148.073zm0 110.925 56.468-32.417L256 295.035l119.242-68.454 56.468 32.417L256 359.868 80.29 258.998zm0 104.929 51.246-29.419L256 405.96l124.464-71.452 51.246 29.419L256 464.798 80.29 363.927z"
                                                                      fill={
                                                                        "#000"
                                                                      }
                                                                    />
                                                                  </g>
                                                                </svg>
                                                                <span
                                                                  className="text-primary"
                                                                  style={{
                                                                    fontSize:
                                                                      "13px",
                                                                    marginLeft:
                                                                      "5px",
                                                                  }}
                                                                >
                                                                  {msg
                                                                    ?.files_path
                                                                    ?.length ===
                                                                  1
                                                                    ? "1 document"
                                                                    : `${msg?.files_path?.length} documents`}
                                                                </span>
                                                              </span>
                                                            </div>
                                                          </Tooltip>
                                                        </div>
                                                      )}
                                                    </div>
                                                    <Collapse
                                                      in={expanded[msgIndex]}
                                                      style={{
                                                        marginLeft: "5px",
                                                      }}
                                                    >
                                                      <ol
                                                        style={{
                                                          marginBottom: "0rem",
                                                          paddingLeft: "10px",
                                                        }}
                                                      >
                                                        {msg?.files_path?.map(
                                                          (file, fileIndex) => (
                                                            <li key={fileIndex}>
                                                              <span
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                  textDecoration:
                                                                    "underline",
                                                                }}
                                                                onClick={() => {
                                                                  viewFiles(
                                                                    file
                                                                  );
                                                                }}
                                                              >
                                                                <i>
                                                                  {file
                                                                    .split("/")
                                                                    .pop()}
                                                                </i>
                                                              </span>
                                                            </li>
                                                          )
                                                        )}
                                                      </ol>
                                                    </Collapse>
                                                  </div>
                                                )
                                              )}

                                              {request?.revised_amount !==
                                                null && (
                                                <div>
                                                  Amount:{" "}
                                                  {request?.revised_amount
                                                    .replace("$$", "$")
                                                    .replace(".00", "")}
                                                </div>
                                              )}
                                              <div>
                                                {request?.accepted_date
                                                  ? "Accepted date: "
                                                  : "Denied date: "}
                                                {request?.accepted_date ||
                                                  request?.denied_date}
                                              </div>
                                              <div>
                                                {request?.accepted_denied_by}{" "}
                                                <strong>
                                                  {request?.accepted_date
                                                    ? "accepted"
                                                    : "denied"}
                                                </strong>{" "}
                                                the change request
                                              </div>
                                            </div>
                                          )
                                        )}
                                    </div>
                                  </div>
                                )}

                                {milestone?.inspection_details?.length > 0 && (
                                  <div
                                    onClick={() => {
                                      setViewInsHistory(!viewInsHistory);
                                    }}
                                    style={{ cursor: "pointer" }}
                                    className="d-flex align-items-center mt-1"
                                  >
                                    <span
                                      style={{
                                        transition: "transform 0.3s ease",
                                        fontSize: "10px",
                                      }}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        version="1.1"
                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                        viewBox="0 0 512 512"
                                        width={15}
                                        height={15}
                                        style={{
                                          enableBackground: "new 0 0 512 512",
                                        }}
                                        xmlSpace="preserve"
                                      >
                                        <g>
                                          <path
                                            d="M420.608 311.463 512 259l-96.612-55.463L512 148.073 256 1.109 0 148.073l96.612 55.463L0 259l91.39 52.463L0 363.927 256 510.89l256-146.963-91.392-52.464zM80.29 148.073 256 47.201l175.71 100.871L256 248.943 80.29 148.073zm0 110.925 56.468-32.417L256 295.035l119.242-68.454 56.468 32.417L256 359.868 80.29 258.998zm0 104.929 51.246-29.419L256 405.96l124.464-71.452 51.246 29.419L256 464.798 80.29 363.927z"
                                            fill={"#000"}
                                          />
                                        </g>
                                      </svg>
                                    </span>
                                    <span
                                      className="ms-2 text-primary"
                                      style={{
                                        color: !viewInsHistory
                                          ? "#0d6efd"
                                          : "lightgray",
                                      }}
                                    >
                                      {!viewInsHistory
                                        ? "View Inspection History"
                                        : "Close Inspection History"}
                                    </span>
                                  </div>
                                )}

                                {viewInsHistory &&
                                  milestone?.inspection_details?.length > 0 && (
                                    <div
                                      style={{
                                        borderLeft: "2px solid lightgray",
                                        marginLeft: "7px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          marginLeft: viewInsHistory
                                            ? "25px"
                                            : "0px",
                                        }}
                                      >
                                        {milestone?.inspection_details?.map(
                                          (inspection, index) => (
                                            <div key={index}>
                                              <strong>
                                                Inspection{" "}
                                                {inspection.inspection_number}:
                                              </strong>
                                              {inspection?.requested_date && (
                                                <div>
                                                  Requested date:{" "}
                                                  {inspection.requested_date}{" "}
                                                </div>
                                              )}
                                              {inspection?.submission_date && (
                                                <div>
                                                  Submission date:{" "}
                                                  {inspection.submission_date}{" "}
                                                </div>
                                              )}
                                              {inspection?.compliance_status && (
                                                <div>
                                                  Inspection Status:{" "}
                                                  {inspection.compliance_status ===
                                                  "meets"
                                                    ? "Compliant"
                                                    : "Non-Compliant"}{" "}
                                                </div>
                                              )}
                                              {inspection?.compliance_comments && (
                                                <div>
                                                  Compliance Notes:{" "}
                                                  {
                                                    inspection.compliance_comments
                                                  }{" "}
                                                </div>
                                              )}
                                              {inspection?.non_compliance_comments && (
                                                <div>
                                                  Non-compliance Notes:{" "}
                                                  {
                                                    inspection.non_compliance_comments
                                                  }{" "}
                                                </div>
                                              )}
                                              {inspection?.inspector && (
                                                <div>
                                                  Inspector Name:{" "}
                                                  {inspection.inspector}{" "}
                                                </div>
                                              )}

                                              {inspection.file_data?.length >
                                                0 && (
                                                <div>
                                                  <Tooltip
                                                    title={
                                                      !expandInspection[index]
                                                        ? "Click to expand files"
                                                        : "Click to collpase files"
                                                    }
                                                    placement="right"
                                                  >
                                                    <div
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      className="d-flex align-items-center"
                                                      onClick={() =>
                                                        toggleExpandInspection(
                                                          index
                                                        )
                                                      }
                                                    >
                                                      <span
                                                        style={{
                                                          transition:
                                                            "transform 0.3s ease",

                                                          fontSize: "10px",
                                                        }}
                                                      >
                                                        <svg
                                                          xmlns="http://www.w3.org/2000/svg"
                                                          version="1.1"
                                                          xmlnsXlink="http://www.w3.org/1999/xlink"
                                                          viewBox="0 0 512 512"
                                                          width={15}
                                                          height={15}
                                                          style={{
                                                            marginBottom: "4px",
                                                            enableBackground:
                                                              "new 0 0 512 512",
                                                          }}
                                                          xmlSpace="preserve"
                                                        >
                                                          <g>
                                                            <path
                                                              d="M420.608 311.463 512 259l-96.612-55.463L512 148.073 256 1.109 0 148.073l96.612 55.463L0 259l91.39 52.463L0 363.927 256 510.89l256-146.963-91.392-52.464zM80.29 148.073 256 47.201l175.71 100.871L256 248.943 80.29 148.073zm0 110.925 56.468-32.417L256 295.035l119.242-68.454 56.468 32.417L256 359.868 80.29 258.998zm0 104.929 51.246-29.419L256 405.96l124.464-71.452 51.246 29.419L256 464.798 80.29 363.927z"
                                                              fill={"#000"}
                                                            />
                                                          </g>
                                                        </svg>
                                                        <span
                                                          className="text-primary"
                                                          style={{
                                                            fontSize: "13px",
                                                            marginLeft: "5px",
                                                          }}
                                                        >
                                                          {inspection.file_data
                                                            ?.length === 1
                                                            ? "1 document"
                                                            : `${inspection.file_data?.length} documents`}
                                                        </span>
                                                      </span>
                                                    </div>
                                                  </Tooltip>

                                                  <Collapse
                                                    in={expandInspection[index]}
                                                    style={{
                                                      marginLeft: "5px",
                                                    }}
                                                  >
                                                    <ol
                                                      style={{
                                                        marginBottom: "0rem",
                                                        paddingLeft: "10px",
                                                        // fontSize: "13px",
                                                      }}
                                                    >
                                                      {inspection.file_data.map(
                                                        (file, fileIndex) => (
                                                          <li
                                                            key={fileIndex}
                                                            style={{
                                                              marginTop: "5px",
                                                            }}
                                                          >
                                                            <span
                                                              style={{
                                                                textDecoration:
                                                                  "underline",
                                                                cursor:
                                                                  "pointer",
                                                              }}
                                                              onClick={() =>
                                                                viewFiles(file)
                                                              }
                                                            >
                                                              <i>
                                                                {file
                                                                  .split("/")
                                                                  .pop()}
                                                              </i>
                                                            </span>
                                                          </li>
                                                        )
                                                      )}
                                                    </ol>
                                                  </Collapse>
                                                </div>
                                              )}
                                            </div>
                                          )
                                        )}
                                      </div>
                                    </div>
                                  )}
                              </div>
                            </div>
                          </div>
                          {selectedPdfFile && mileChatContract && (
                            <>
                              <div className="dropdown-divider"></div>

                              <iframe
                                title="PDF Viewer"
                                src={selectedPdfFile}
                                style={{ ...iframeStyle, height: "290px" }}
                              />
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="col-md-6 pt-3 ps-4 pb-3">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="milestonechangeRequest"></div>
                    <div className="text-end">
                      <span className="text-dark" style={{ fontWeight: 600 }}>
                        {" "}
                        Chat with :{" "}
                      </span>

                      <ToggleButtonGroup
                        value={chatWith}
                        exclusive
                        onChange={handleToggle}
                        sx={{ marginLeft: "10px", textTransform: "none" }}
                        size="small"
                      >
                        <ToggleButton
                          style={{ textTransform: "none" }}
                          value="owner"
                          disabled={
                            selectedMileStone?.status ===
                              "Inspection Initiated" ||
                            selectedMileStone?.row?.status ===
                              "Inspection Initiated" ||
                            selectedMileStone?.row?.inspector_chart_relationship
                              ?.toLowerCase()
                              .includes("contract") ||
                            selectedMileStone?.relation_status
                              ?.toLowerCase()
                              .includes("contract")
                          }
                        >
                          {selectedOwner?.owner_details?.owner_name}(Owner)
                        </ToggleButton>
                        <ToggleButton
                          style={{ textTransform: "none" }}
                          value="contractor"
                          disabled={
                            (!selectedMileStone?.row?.status &&
                              !selectedMileStone?.status) ||
                            selectedMileStone?.row?.inspector_chart_relationship
                              ?.toLowerCase()
                              .includes("owner") ||
                            selectedMileStone?.relation_status
                              ?.toLowerCase()
                              .includes("owner")
                          }
                        >
                          {selectedOwner?.contractor_details?.contractor_name}
                          (Contractor)
                        </ToggleButton>
                      </ToggleButtonGroup>
                    </div>
                  </div>

                  <>
                    <div className="w-100" style={{ marginTop: "2%" }}>
                      <div
                        style={{
                          border: "1px solid #ccc",
                          padding: "10px",
                          width: "100%",
                        }}
                      >
                        <div
                          style={{
                            height: "380px",
                            overflowY: "scroll",
                          }}
                        >
                          {Nochat && (
                            <div className="d-flex justify-content-center">
                              <span className="text-secondary text-center fw-normal">
                                No Chat History available
                              </span>
                            </div>
                          )}
                          {messages.map((message, index) => (
                            <>
                              <div
                                key={index}
                                className={`message ${
                                  message?.user == "Inspector"
                                    ? "user-message"
                                    : "ai-message"
                                }`}
                              >
                                {message.chat}
                              </div>
                            </>
                          ))}
                        </div>
                        <div
                          style={{ marginTop: "10px" }}
                          className="d-flex me-4"
                        >
                          <TextField
                            id="chatInput"
                            type="text"
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                paddingRight: "0px",
                              },
                              "& .MuiInputBase-input": {
                                padding: "10px",
                                backgroundColor: "#FFF",
                                borderRadius: "4px",
                                border: "0px",
                                fontSize: "12px",
                              },
                            }}
                            size="small"
                            className="chatinput"
                            style={{ borderRight: "0px" }}
                            value={newMessage}
                            placeholder="Type your message here..."
                            onChange={(e) => {
                              const trimmedValue = e.target.value.trim();
                              if (trimmedValue || e.target.value.length === 0) {
                                setNewMessage(e.target.value);
                              }
                            }}
                            fullWidth
                            // onKeyDown={(e) => {
                            //   if (
                            //     e.key === "Enter" &&
                            //     newMessage.trim() !== ""
                            //   ) {
                            //     handleSendMessage();
                            //     sendchat();
                            //   }
                            // }}
                            InputProps={{
                              endAdornment: (
                                <>
                                  <InputAdornment position="end">
                                    <IconButton
                                      onClick={() => {
                                        if (newMessage.trim() !== "") {
                                          handleSendMessage();
                                          sendchat();
                                        }
                                      }}
                                      className="btn chatbtn mt-1"
                                      style={{
                                        backgroundColor: "transparent",
                                        borderLeft: "0px",
                                      }}
                                      disabled={newMessage.trim() === ""}
                                    >
                                      <SendIcon
                                        style={{
                                          color:
                                            newMessage.trim() === ""
                                              ? "gray"
                                              : "#013e6a",
                                        }}
                                      />
                                    </IconButton>
                                  </InputAdornment>
                                </>
                              ),
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Modal
        open={Changecontract}
        onClose={() => {
          // setChangeContract(false);
          setSelectedPdf(null);
          setTextAreaValues([]);
          setEnableTextarea(Array(ContractChangeRequest.length).fill(false));
          setEditmilestone(false);
          setMileChat(false);
          setMileChatContract(false);
          setMilestoneChangeRequest([]);
          setSelectedMilestone(null);
          setFileError("");
          setError("");
          setViewCR(false);
          setViewInsHistory(false);
          setExpanded({});
          setExpandInspection({});
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modelStyle}>
          <div
            style={{
              position: "sticky",
              top: "0",
              backgroundColor: "white",
              zIndex: 1,
              padding: "10px 20px 5px 20px",
              borderBottom: "1px solid lightgray",
            }}
            className="d-flex align-items-center justify-content-between"
          >
            <div>
              <h5>
                {chatview && (
                  <span
                    onClick={() => {
                      setChatView(false);
                    }}
                  >
                    <IoIosArrowRoundBack style={{ fontSize: "25px" }} />
                  </span>
                )}
                <span className="ps-2">Project</span>
                <span> : </span>{" "}
                <span className="projectname"> {changeprojectname}</span>
              </h5>
            </div>
            <div className="d-flex align-items-center">
              <span className="me-2">
                <Tooltip
                  title={
                    !openContract
                      ? "Click to view contract"
                      : "Click to close contract"
                  }
                  placement="left"
                >
                  {selectedPdfFile && (
                    <div
                      className="cursor"
                      onClick={() => {
                        setOpenContract(!openContract);
                      }}
                    >
                      {!openContract ? (
                        <PictureAsPdfRoundedIcon className="text-primary" />
                      ) : (
                        <svg
                          class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium text-primary css-i4bv87-MuiSvgIcon-root"
                          focusable="false"
                          aria-hidden="true"
                          viewBox="0 0 24 24"
                          data-testid="PictureAsPdfRoundedIcon"
                          fill="#0d6efd"
                          width={"24"}
                          height={"24"}
                        >
                          <path d="M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v1.25c0 .41-.34.75-.75.75s-.75-.34-.75-.75V8c0-.55.45-1 1-1H10c.83 0 1.5.67 1.5 1.5zm5 2c0 .83-.67 1.5-1.5 1.5h-2c-.28 0-.5-.22-.5-.5v-5c0-.28.22-.5.5-.5h2c.83 0 1.5.67 1.5 1.5zm4-3.75c0 .41-.34.75-.75.75H19v1h.75c.41 0 .75.34.75.75s-.34.75-.75.75H19v1.25c0 .41-.34.75-.75.75s-.75-.34-.75-.75V8c0-.55.45-1 1-1h1.25c.41 0 .75.34.75.75M9 9.5h1v-1H9zM3 6c-.55 0-1 .45-1 1v13c0 1.1.9 2 2 2h13c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1-.45-1-1V7c0-.55-.45-1-1-1m11 5.5h1v-3h-1z"></path>

                          <path
                            d="M4 4L20 20"
                            stroke="gray"
                            stroke-width="2"
                            stroke-linecap="round"
                          />
                          <path
                            d="M4 20L20 4"
                            stroke="gray"
                            stroke-width="2"
                            stroke-linecap="round"
                          />
                        </svg>
                      )}
                    </div>
                  )}
                </Tooltip>
              </span>
              <IoIosClose
                className="fs-1 cursor"
                onClick={() => {
                  setChangeContract(false);
                  setContractChangeRequest([]);
                  setChatView(false);
                  setEditIndex(null);
                  setMileChat(false);
                  setMileChatContract(false);
                  setMilestoneChangeRequest([]);
                  setFileError("");
                  setError("");
                }}
              />
            </div>
          </div>

          {/* <div className="dropdown-divider"></div> */}
          <div className={`pt-3 ps-3 pe-3 ${chatview && "pb-3"}`}>
            {selectedPdfFile && openContract && (
              <iframe
                title="PDF Viewer"
                src={selectedPdfFile}
                style={{ ...iframeStyle, height: "400px" }}
              />
            )}
            <div>
              <div
                className={`d-flex row m-auto custom-row ${
                  selectedPdfFile && openContract && "mt-2"
                }`}
              >
                <div className={chatview ? "col-md-6" : "col-md-12"}>
                  {" "}
                  {ContractChangeRequest.map((milestone, index) => (
                    <div
                      key={index}
                      className="row custom-row"
                      style={{ margin: "0px !important" }}
                    >
                      <div className={chatview ? "col-md-12" : ""}>
                        <div className="d-flex justify-content-between">
                          <div className="d-flex">
                            <>
                              {" "}
                              {editmilestone === true ? (
                                <>
                                  <p className="me-2">Amount: </p>
                                  <TextField
                                    style={{
                                      border: "1px solid lightgray",
                                      borderBottom: "0px !important",
                                      outline: "none",
                                      height: "70%",
                                    }}
                                    className="budgetinput form-control me-2"
                                    value={milestone?.milestone_amount}
                                    onChange={(e) =>
                                      handleInputChange(
                                        e,
                                        index,
                                        "milestone_amount"
                                      )
                                    }
                                    name="project_budget"
                                    id="formatted-numberformat-input"
                                    placeholder="Project Budget"
                                    InputProps={{
                                      inputComponent: NumericFormatCustom,
                                    }}
                                    variant="standard"
                                  />
                                </>
                              ) : (
                                <div className="d-flex align-items-center"></div>
                              )}
                            </>
                          </div>
                        </div>

                        <div>
                          <div className="row g-3 d-flex align-items-stretch">
                            {/* Left Section */}
                            <div className="col-12 col-md-6 d-flex flex-column">
                              <div className="mb-2">
                                <label
                                  className="milestonechangeRequest"
                                  style={{ width: "32%" }}
                                >
                                  Milestone{" "}
                                </label>
                                <span className="text-center">
                                  {" : "}
                                  {milNum + ". " + milestone?.milestone}
                                </span>
                              </div>

                              {milestone?.original_amount !== null &&
                                milestone?.original_amount !== "" && (
                                  <div className="mb-2">
                                    <label
                                      className="milestonechangeRequest"
                                      style={{ minWidth: "32%" }}
                                    >
                                      Original Amount
                                    </label>
                                    <span className="text-center">
                                      {" : "}
                                      {milestone.original_amount.includes("$")
                                        ? milestone.original_amount.replace(
                                            ".00",
                                            ""
                                          )
                                        : `${
                                            "$" +
                                            milestone.original_amount.replace(
                                              ".00",
                                              ""
                                            )
                                          }`}
                                    </span>
                                  </div>
                                )}
                              <div className="mb-2">
                                <label
                                  className="milestonechangeRequest"
                                  // style={{ width: "32%" }}
                                >
                                  Milestone Description{" "}
                                </label>

                                <span>
                                  <div
                                    style={{
                                      marginTop: "10px",
                                      overflowY: "auto",
                                      overflowX: "hidden",
                                      maxHeight: "150px",
                                      whiteSpace: "pre-wrap",
                                      wordBreak: "break-word",
                                      height: "auto",
                                    }}
                                  >
                                    <div>{milestone.milestone_description}</div>
                                    {milestone?.change_request?.length > 0 && (
                                      <div
                                        onClick={() => {
                                          setViewCR(!viewCR);
                                        }}
                                        style={{ cursor: "pointer" }}
                                        className="d-flex align-items-center mt-1"
                                      >
                                        <span
                                          style={{
                                            transition: "transform 0.3s ease",
                                            fontSize: "10px",
                                          }}
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            version="1.1"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            viewBox="0 0 512 512"
                                            width={15}
                                            height={15}
                                            style={{
                                              enableBackground:
                                                "new 0 0 512 512",
                                            }}
                                            xmlSpace="preserve"
                                          >
                                            <g>
                                              <path
                                                d="M420.608 311.463 512 259l-96.612-55.463L512 148.073 256 1.109 0 148.073l96.612 55.463L0 259l91.39 52.463L0 363.927 256 510.89l256-146.963-91.392-52.464zM80.29 148.073 256 47.201l175.71 100.871L256 248.943 80.29 148.073zm0 110.925 56.468-32.417L256 295.035l119.242-68.454 56.468 32.417L256 359.868 80.29 258.998zm0 104.929 51.246-29.419L256 405.96l124.464-71.452 51.246 29.419L256 464.798 80.29 363.927z"
                                                fill={"#000"}
                                              />
                                            </g>
                                          </svg>
                                        </span>
                                        <span
                                          className="ms-2 text-primary"
                                          style={{
                                            color: !viewCR
                                              ? "#0d6efd"
                                              : "lightgray",
                                          }}
                                        >
                                          {!viewCR
                                            ? "View Change Request History"
                                            : "Close Change Request History"}
                                        </span>
                                      </div>
                                    )}
                                    {viewCR && (
                                      <div
                                        style={{
                                          borderLeft: "2px solid lightgray",
                                          marginLeft: "7px",
                                        }}
                                      >
                                        <div
                                          style={{
                                            marginLeft: viewCR ? "25px" : "0px",
                                          }}
                                        >
                                          {milestone?.change_request?.length >
                                            0 &&
                                            milestone?.change_request.map(
                                              (request, index) => (
                                                <div
                                                  key={index}
                                                  style={{
                                                    marginTop: "5px",
                                                  }}
                                                >
                                                  <strong>
                                                    {
                                                      request?.change_request_heading
                                                    }
                                                    {":"}
                                                  </strong>

                                                  <div>
                                                    {"Initiated Date: " +
                                                      request.initiate_date}
                                                  </div>
                                                  <div>
                                                    {
                                                      request
                                                        ?.change_request_description?.[0]
                                                        ?.user_name
                                                    }{" "}
                                                    (
                                                    {
                                                      request
                                                        ?.change_request_description?.[0]
                                                        ?.user_role
                                                    }
                                                    ) initiated a change request
                                                  </div>
                                                  {request?.change_request_description?.map(
                                                    (msg, msgIndex) => (
                                                      <div>
                                                        <div key={msgIndex}>
                                                          <span>
                                                            {msg?.user_name} (
                                                            {msg?.user_role}):{" "}
                                                            {msg?.message}
                                                          </span>

                                                          {msg?.files_path
                                                            ?.length > 0 && (
                                                            <div
                                                              style={{
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                              }}
                                                            >
                                                              <Tooltip
                                                                title={
                                                                  !expanded[
                                                                    msgIndex
                                                                  ]
                                                                    ? "Click to expand files"
                                                                    : "Click to collpase files"
                                                                }
                                                                placement="right"
                                                              >
                                                                <div
                                                                  style={{
                                                                    cursor:
                                                                      "pointer",
                                                                  }}
                                                                  className="d-flex align-items-center"
                                                                  onClick={() =>
                                                                    toggleExpand(
                                                                      msgIndex
                                                                    )
                                                                  }
                                                                >
                                                                  <span
                                                                    style={{
                                                                      transition:
                                                                        "transform 0.3s ease",

                                                                      fontSize:
                                                                        "10px",
                                                                    }}
                                                                  >
                                                                    <svg
                                                                      xmlns="http://www.w3.org/2000/svg"
                                                                      version="1.1"
                                                                      xmlnsXlink="http://www.w3.org/1999/xlink"
                                                                      viewBox="0 0 512 512"
                                                                      width={15}
                                                                      height={
                                                                        15
                                                                      }
                                                                      style={{
                                                                        marginBottom:
                                                                          "4px",
                                                                        enableBackground:
                                                                          "new 0 0 512 512",
                                                                      }}
                                                                      xmlSpace="preserve"
                                                                    >
                                                                      <g>
                                                                        <path
                                                                          d="M420.608 311.463 512 259l-96.612-55.463L512 148.073 256 1.109 0 148.073l96.612 55.463L0 259l91.39 52.463L0 363.927 256 510.89l256-146.963-91.392-52.464zM80.29 148.073 256 47.201l175.71 100.871L256 248.943 80.29 148.073zm0 110.925 56.468-32.417L256 295.035l119.242-68.454 56.468 32.417L256 359.868 80.29 258.998zm0 104.929 51.246-29.419L256 405.96l124.464-71.452 51.246 29.419L256 464.798 80.29 363.927z"
                                                                          fill={
                                                                            "#000"
                                                                          }
                                                                        />
                                                                      </g>
                                                                    </svg>
                                                                    <span
                                                                      className="text-primary"
                                                                      style={{
                                                                        fontSize:
                                                                          "13px",
                                                                        marginLeft:
                                                                          "5px",
                                                                      }}
                                                                    >
                                                                      {msg
                                                                        ?.files_path
                                                                        ?.length ===
                                                                      1
                                                                        ? "1 document"
                                                                        : `${msg?.files_path?.length} documents`}
                                                                    </span>
                                                                  </span>
                                                                </div>
                                                              </Tooltip>
                                                            </div>
                                                          )}
                                                        </div>
                                                        <Collapse
                                                          in={
                                                            expanded[msgIndex]
                                                          }
                                                          style={{
                                                            marginLeft: "5px",
                                                          }}
                                                        >
                                                          <ol
                                                            style={{
                                                              marginBottom:
                                                                "0rem",
                                                              paddingLeft:
                                                                "10px",
                                                            }}
                                                          >
                                                            {msg?.files_path?.map(
                                                              (
                                                                file,
                                                                fileIndex
                                                              ) => (
                                                                <li
                                                                  key={
                                                                    fileIndex
                                                                  }
                                                                >
                                                                  <span
                                                                    style={{
                                                                      cursor:
                                                                        "pointer",
                                                                      textDecoration:
                                                                        "underline",
                                                                    }}
                                                                    onClick={() => {
                                                                      viewFiles(
                                                                        file
                                                                      );
                                                                    }}
                                                                  >
                                                                    <i>
                                                                      {file
                                                                        .split(
                                                                          "/"
                                                                        )
                                                                        .pop()}
                                                                    </i>
                                                                  </span>
                                                                </li>
                                                              )
                                                            )}
                                                          </ol>
                                                        </Collapse>
                                                      </div>
                                                    )
                                                  )}

                                                  {request?.revised_amount !==
                                                    null && (
                                                    <div>
                                                      Amount:{" "}
                                                      {request?.revised_amount
                                                        .replace("$$", "$")
                                                        .replace(".00", "")}
                                                    </div>
                                                  )}
                                                  <div>
                                                    {request?.accepted_date
                                                      ? "Accepted date: "
                                                      : "Denied date: "}
                                                    {request?.accepted_date ||
                                                      request?.denied_date}
                                                  </div>
                                                  <div>
                                                    {
                                                      request?.accepted_denied_by
                                                    }{" "}
                                                    <strong>
                                                      {request?.accepted_date
                                                        ? "accepted"
                                                        : "denied"}
                                                    </strong>{" "}
                                                    the change request
                                                  </div>
                                                </div>
                                              )
                                            )}
                                        </div>
                                      </div>
                                    )}

                                    {milestone?.inspection_details?.length >
                                      0 && (
                                      <div
                                        onClick={() => {
                                          setViewInsHistory(!viewInsHistory);
                                        }}
                                        style={{ cursor: "pointer" }}
                                        className="d-flex align-items-center mt-1"
                                      >
                                        <span
                                          style={{
                                            transition: "transform 0.3s ease",
                                            fontSize: "10px",
                                          }}
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            version="1.1"
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            viewBox="0 0 512 512"
                                            width={15}
                                            height={15}
                                            style={{
                                              enableBackground:
                                                "new 0 0 512 512",
                                            }}
                                            xmlSpace="preserve"
                                          >
                                            <g>
                                              <path
                                                d="M420.608 311.463 512 259l-96.612-55.463L512 148.073 256 1.109 0 148.073l96.612 55.463L0 259l91.39 52.463L0 363.927 256 510.89l256-146.963-91.392-52.464zM80.29 148.073 256 47.201l175.71 100.871L256 248.943 80.29 148.073zm0 110.925 56.468-32.417L256 295.035l119.242-68.454 56.468 32.417L256 359.868 80.29 258.998zm0 104.929 51.246-29.419L256 405.96l124.464-71.452 51.246 29.419L256 464.798 80.29 363.927z"
                                                fill={"#000"}
                                              />
                                            </g>
                                          </svg>
                                        </span>
                                        <span
                                          className="ms-2 text-primary"
                                          style={{
                                            color: !viewInsHistory
                                              ? "#0d6efd"
                                              : "lightgray",
                                          }}
                                        >
                                          {!viewInsHistory
                                            ? "View Inspection History"
                                            : "Close Inspection History"}
                                        </span>
                                      </div>
                                    )}

                                    {viewInsHistory &&
                                      milestone?.inspection_details?.length >
                                        0 && (
                                        <div
                                          style={{
                                            borderLeft: "2px solid lightgray",
                                            marginLeft: "7px",
                                          }}
                                        >
                                          <div
                                            style={{
                                              marginLeft: viewInsHistory
                                                ? "25px"
                                                : "0px",
                                            }}
                                          >
                                            {milestone?.inspection_details?.map(
                                              (inspection, index) => (
                                                <div key={index}>
                                                  <strong>
                                                    Inspection{" "}
                                                    {
                                                      inspection.inspection_number
                                                    }
                                                    :
                                                  </strong>
                                                  {inspection.requested_date && (
                                                    <div>
                                                      Requested date:{" "}
                                                      {
                                                        inspection.requested_date
                                                      }{" "}
                                                    </div>
                                                  )}
                                                  {inspection.submission_date && (
                                                    <div>
                                                      Submission date:{" "}
                                                      {
                                                        inspection.submission_date
                                                      }{" "}
                                                    </div>
                                                  )}
                                                  <div>
                                                    Inspection Status:{" "}
                                                    {inspection?.compliance_status ===
                                                    "meets"
                                                      ? "Compliant"
                                                      : "Non-Compliant"}{" "}
                                                  </div>
                                                  {inspection?.compliance_comments && (
                                                    <div>
                                                      Compliance Notes:{" "}
                                                      {
                                                        inspection.compliance_comments
                                                      }{" "}
                                                    </div>
                                                  )}
                                                  {inspection?.non_compliance_comments && (
                                                    <div>
                                                      Non-compliance Notes:{" "}
                                                      {
                                                        inspection.non_compliance_comments
                                                      }{" "}
                                                    </div>
                                                  )}
                                                  {inspection?.inspector && (
                                                    <div>
                                                      Inspector Name:{" "}
                                                      {inspection.inspector}{" "}
                                                    </div>
                                                  )}

                                                  {inspection.file_data
                                                    ?.length > 0 && (
                                                    <div>
                                                      <Tooltip
                                                        title={
                                                          !expandInspection[
                                                            index
                                                          ]
                                                            ? "Click to expand files"
                                                            : "Click to collpase files"
                                                        }
                                                        placement="right"
                                                      >
                                                        <div
                                                          style={{
                                                            cursor: "pointer",
                                                          }}
                                                          className="d-flex align-items-center"
                                                          onClick={() =>
                                                            toggleExpandInspection(
                                                              index
                                                            )
                                                          }
                                                        >
                                                          <span
                                                            style={{
                                                              transition:
                                                                "transform 0.3s ease",

                                                              fontSize: "10px",
                                                            }}
                                                          >
                                                            <svg
                                                              xmlns="http://www.w3.org/2000/svg"
                                                              version="1.1"
                                                              xmlnsXlink="http://www.w3.org/1999/xlink"
                                                              viewBox="0 0 512 512"
                                                              width={15}
                                                              height={15}
                                                              style={{
                                                                marginBottom:
                                                                  "4px",
                                                                enableBackground:
                                                                  "new 0 0 512 512",
                                                              }}
                                                              xmlSpace="preserve"
                                                            >
                                                              <g>
                                                                <path
                                                                  d="M420.608 311.463 512 259l-96.612-55.463L512 148.073 256 1.109 0 148.073l96.612 55.463L0 259l91.39 52.463L0 363.927 256 510.89l256-146.963-91.392-52.464zM80.29 148.073 256 47.201l175.71 100.871L256 248.943 80.29 148.073zm0 110.925 56.468-32.417L256 295.035l119.242-68.454 56.468 32.417L256 359.868 80.29 258.998zm0 104.929 51.246-29.419L256 405.96l124.464-71.452 51.246 29.419L256 464.798 80.29 363.927z"
                                                                  fill={"#000"}
                                                                />
                                                              </g>
                                                            </svg>
                                                            <span
                                                              className="text-primary"
                                                              style={{
                                                                fontSize:
                                                                  "13px",
                                                                marginLeft:
                                                                  "5px",
                                                              }}
                                                            >
                                                              {inspection
                                                                .file_data
                                                                ?.length === 1
                                                                ? "1 document"
                                                                : `${inspection.file_data?.length} documents`}
                                                            </span>
                                                          </span>
                                                        </div>
                                                      </Tooltip>

                                                      <Collapse
                                                        in={
                                                          expandInspection[
                                                            index
                                                          ]
                                                        }
                                                        style={{
                                                          marginLeft: "5px",
                                                        }}
                                                      >
                                                        <ol
                                                          style={{
                                                            marginBottom:
                                                              "0rem",
                                                            paddingLeft: "10px",
                                                            // fontSize: "13px",
                                                          }}
                                                        >
                                                          {inspection.file_data.map(
                                                            (
                                                              file,
                                                              fileIndex
                                                            ) => (
                                                              <li
                                                                key={fileIndex}
                                                                style={{
                                                                  marginTop:
                                                                    "5px",
                                                                }}
                                                              >
                                                                <span
                                                                  style={{
                                                                    textDecoration:
                                                                      "underline",
                                                                    cursor:
                                                                      "pointer",
                                                                  }}
                                                                  onClick={() =>
                                                                    viewFiles(
                                                                      file
                                                                    )
                                                                  }
                                                                >
                                                                  <i>
                                                                    {file
                                                                      .split(
                                                                        "/"
                                                                      )
                                                                      .pop()}
                                                                  </i>
                                                                </span>
                                                              </li>
                                                            )
                                                          )}
                                                        </ol>
                                                      </Collapse>
                                                    </div>
                                                  )}
                                                </div>
                                              )
                                            )}
                                          </div>
                                        </div>
                                      )}
                                  </div>
                                </span>
                              </div>
                              {files.length !== 0 && (
                                <div className="mb-2">
                                  <label className="milestonechangeRequest">
                                    Attached Inspection Reports{" "}
                                  </label>
                                </div>
                              )}
                              {files.length !== 0 && (
                                <div className=" d-flex preview-container">
                                  {files?.map((item, index) => (
                                    <div key={index} className="preview-item">
                                      <Tooltip
                                        title={`Click to view (${item.name})`}
                                        placement="right"
                                      >
                                        <div
                                          style={{
                                            width: "50px",
                                            height: "50px",
                                            color: "gray",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            if (item.type !== "other") {
                                              setContractDocuments(true);
                                              setSelectedContractDoc(
                                                URL.createObjectURL(item.blob)
                                              );
                                            } else {
                                              const link =
                                                document.createElement("a");
                                              link.href = item.blob;
                                              link.download = item.name; // Set file name for download
                                              document.body.appendChild(link);
                                              link.click();
                                              document.body.removeChild(link);
                                            }
                                          }}
                                        >
                                          <TextSnippetIcon
                                            style={{
                                              width: "100%",
                                              height: "100%",
                                              color: "#F5AE41",
                                              opacity: "0.9",
                                            }}
                                          />
                                          <div
                                            style={{
                                              overflow: "none",
                                              fontSize: "12px",
                                              textAlign: "center",
                                            }}
                                          >
                                            {item?.name &&
                                              item?.name.substring(0, 2) +
                                                "..." +
                                                item?.name.substring(
                                                  item?.name.length - 4
                                                )}
                                          </div>
                                        </div>
                                      </Tooltip>
                                      <button
                                        className="delete-btn"
                                        onClick={() => handleDelete(index)}
                                      >
                                        X
                                      </button>
                                    </div>
                                  ))}
                                </div>
                              )}
                              {fileError !== "" && (
                                <div
                                  className="mt-3 text-danger"
                                  style={{ fontSize: "14px" }}
                                >
                                  {fileError}
                                </div>
                              )}
                            </div>

                            {/* Right Section */}
                            <div className="col-12 col-md-6 d-flex flex-column">
                              <div className="mb-2 flex-grow-1 d-flex flex-column">
                                <header>Compliant Notes</header>
                                <textarea
                                  type="text"
                                  value={comments.negative}
                                  onChange={(e) => {
                                    setFileError("");
                                    setComments((prev) => ({
                                      ...prev,
                                      negative: e.target.value,
                                    }));
                                  }}
                                  className="form-control flex-grow-1"
                                  rows={3}
                                  // maxLength={250}
                                  placeholder="Compliant Notes"
                                />
                              </div>

                              <div className="flex-grow-1 d-flex flex-column">
                                <header>Non-compliant Notes</header>
                                <textarea
                                  ref={complaintRef}
                                  type="text"
                                  value={comments.positive}
                                  onChange={(e) => {
                                    setError("");
                                    setFileError("");
                                    setComments((prev) => ({
                                      ...prev,
                                      positive: e.target.value,
                                    }));
                                  }}
                                  // maxLength={250}
                                  className="form-control flex-grow-1"
                                  rows={3}
                                  placeholder="Non-compliant Notes"
                                />
                                {error && (
                                  <p
                                    className="text-danger"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {error}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>

                          {/* )} */}

                          <p></p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="col-md-6 ">
                  {chatview && (
                    <div className="d-flex align-items-center justify-content-between">
                      <h5 className="projectname">
                        <span className="text-dark"> Milestone : </span>
                        {milestonechangeRequestchat?.milestone}
                      </h5>
                      <div>
                        <span className="text-dark" style={{ fontWeight: 600 }}>
                          {" "}
                          Chat with :{" "}
                        </span>
                        <select
                          style={{
                            height: "40px",
                            borderRadius: "2px",
                            marginLeft: "10px",
                            color: "gray",
                            fontSize: "14px",
                            border: "1px solid lightgrey",
                            width: "40%",
                          }}
                        >
                          <option value="owner">Owner</option>
                          <option value="contractor">Contractor</option>
                        </select>
                      </div>
                    </div>
                  )}
                  {chatview && (
                    <>
                      <div className="w-100" style={{ marginTop: "2%" }}>
                        <div
                          style={{
                            border: "1px solid #ccc",
                            padding: "10px",
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              height: "380px",
                              overflowY: "scroll",
                            }}
                          >
                            {Nochat && (
                              <div className="d-flex justify-content-center">
                                <span className="text-secondary text-center fw-normal">
                                  No Chat History available
                                </span>
                              </div>
                            )}
                            {messages.map((message, index) => (
                              <>
                                <div
                                  key={index}
                                  className={`message ${
                                    message?.user == "Contractor"
                                      ? "user-message"
                                      : "ai-message"
                                  }`}
                                >
                                  {message.chat}
                                </div>
                              </>
                            ))}
                          </div>
                          <div
                            style={{ marginTop: "10px" }}
                            className="d-flex me-4"
                          >
                            <input
                              id="chatInput"
                              type="text"
                              className="chatinput"
                              value={newMessage}
                              onChange={(e) => {
                                const trimmedValue = e.target.value.trim();
                                if (
                                  trimmedValue ||
                                  e.target.value.length === 0
                                ) {
                                  setNewMessage(e.target.value);
                                }
                              }}
                              placeholder="Type your message here..."
                              // onKeyDown={(e) => {
                              //   if (
                              //     e.key === "Enter" &&
                              //     sendcomment === "enable"
                              //   ) {
                              //     handleSendMessage();
                              //     sendchat();
                              //   }
                              // }}
                            />
                            <button
                              onClick={() => {
                                handleSendMessage();
                                sendchat();
                              }}
                              className="btn chatbtn mt-1"
                              style={{
                                backgroundColor:
                                  sendcomment !== "enable" ? "gray" : "#013e6a",
                              }}
                              disabled={sendcomment !== "enable"}
                            >
                              Send
                            </button>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>

                {!chatview && (
                  <div
                    className={`d-flex row m-auto ${
                      files.length === 0 ? "" : "align-items-center"
                    }`}
                  >
                    <div
                      className={` mt-3 m-auto ${
                        files.length === 0 ? "drag-area" : "inspector-drag-area"
                      }`}
                    >
                      <label
                        htmlFor="pdfFiles"
                        className="text-center m-auto bg-white cursor"
                      >
                        <>
                          <div class="icon">
                            <i class="fas fa-cloud-upload-alt"></i>
                          </div>
                          <input
                            type="file"
                            id="pdfFiles"
                            name="pdfFiles"
                            // accept="image/*, video/*, .pdf, .doc,"
                            accept="*/*"
                            onChange={handleInspectorFileChange}
                            style={{ display: "none" }}
                          />
                          <>
                            <>
                              <header>
                                {" "}
                                Upload Inspection Report(s)
                                <span className="text-danger">*</span>
                              </header>
                              <p
                                style={{
                                  fontSize: "14px",
                                  color: "gray",
                                  marginBottom: "5px",
                                }}
                              >
                                {/* Accepted file formats: Images (JPG, PNG, GIF),
                              Videos (MP4, AVI, MOV), Documents (PDF, DOC, DOCX) */}
                                {/* Accepted file formats: JPG, PNG, GIF, MP4, and
                                PDF */}
                                Maximum file size: 200MB
                                {/* (up to 200MB). */}
                              </p>
                            </>
                          </>
                        </>
                      </label>
                    </div>
                  </div>
                )}

                <div
                  style={{
                    background: "white",
                    position: "sticky",
                    padding: "10px",
                    bottom: 0,
                    zIndex: 2,
                  }}
                >
                  <div className="mt-3 d-flex justify-content-end">
                    {" "}
                    <button
                      className="btn detail-btn me-2 bg-danger text-white"
                      onClick={() => {
                        if (
                          files.length > 0 &&
                          comments.positive.trim() !== ""
                        ) {
                          setLoader(true);
                          submitReport("does not meet");
                        } else {
                          try {
                            complaintRef.current.focus();
                          } catch {
                            console.log("Not found");
                          }

                          setError("Please fill this field");
                        }
                      }}
                      disabled={files.length === 0 || isLoader}
                    >
                      {isLoader && <span className="round_loader" />}{" "}
                      <span style={{ marginLeft: isLoader ? "5px" : "" }}>
                        Does Not Meet Contract Terms
                      </span>
                    </button>
                    <button
                      className="btn btn-cvault"
                      onClick={() => {
                        if (files.length > 0) {
                          setLoader(true);
                          submitReport("meets");
                        }
                      }}
                      disabled={
                        files.length === 0 ||
                        isLoader ||
                        comments.positive.trim() !== ""
                      }
                    >
                      {isLoader && <span className="round_loader" />}{" "}
                      <span
                        style={{
                          marginLeft: isLoader ? "5px" : "",
                          fontSize: "14px",
                        }}
                      >
                        Meets Contract Terms
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Modal>

      <Modal
        open={Reuploadcontract}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={Reupload}>
          <div className="mt-1 ">
            <div>
              <div className="d-flex justify-content-between">
                <div>
                  <h5>
                    Contract PDF<span className="text-danger  fs-4">*</span>
                  </h5>
                </div>
                <div className="d-flex">
                  <button
                    className="btn detail-btn ms-auto  me-2"
                    onClick={() => {
                      setChangeContract(false);
                      setSelectedPdf(null);
                      setTextAreaValues([]);
                      setEnableTextarea(
                        Array(ContractChangeRequest.length).fill(false)
                      );
                      setEditmilestone(false);
                      setReUplodacontract(false);
                      setChangeProjectid("");
                      setState({
                        project_budget: "",
                      });
                      setReuploadSelectedPdf(null);
                      setAImessage(false);
                      setGenAI(false);
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-cvault"
                    onClick={() => {
                      Acceptproject();
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
            <div className="dropdown-divider"></div>
            <div className="d-flex justify-content-end me-4">
              {" "}
              <p class="aliens d-flex mt-2 ">
                <span>G</span>
                <span>E</span>
                <span>N</span>
                <span>-</span>
                <span>A</span>
                <span>I</span>
              </p>
              <Switch
                checked={genAI}
                onChange={genAIChange}
                color="success"
                className="ms-1"
              />
            </div>
            <div>
              <div className="drag-area  px-5 mt-3">
                <label
                  htmlFor="pdfFile"
                  className="text-center m-auto bg-white w-50 cursor"
                >
                  <>
                    <div class="icon">
                      <i class="fas fa-cloud-upload-alt"></i>
                    </div>
                    <input
                      type="file"
                      id="pdfFile"
                      key={selectedPdf ? selectedPdf.name : "defaultKey"}
                      name="pdfFile"
                      accept=".pdf"
                      onChange={handleFileChange}
                      style={{ display: "none" }}
                    />
                    <>
                      <header> Upload Contract</header>
                    </>
                  </>
                </label>
              </div>
              <div className="d-flex justify-content-between">
                {" "}
                <div>
                  {" "}
                  {selectedPdf && (
                    <p className="m-auto mt-3">
                      Uploaded Contract:
                      <span className="text-danger"> {filename}</span>
                    </p>
                  )}
                </div>
                <div>
                  {" "}
                  {selectedPdf && (
                    <div className=" d-flex mt-3">
                      <label for="budget w-100">
                        {" "}
                        Project Budget
                        <span className="text-danger fs-4">*</span>{" "}
                      </label>
                      <TextField
                        inputRef={projectBudgetRef}
                        style={{
                          border: "1px solid lightgray",
                          borderBottom: "0px !important",
                          outline: "none",
                          width: "60%",
                        }}
                        className="budgetinput form-control mt-1"
                        value={state.project_budget}
                        onChange={handleChange}
                        name="project_budget"
                        id="formatted-numberformat-input"
                        placeholder="Project Budget"
                        InputProps={{
                          inputComponent: NumericFormatCustom,
                        }}
                        variant="standard"
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className="row m-auto custom-row">
                <div className="col-md-6  mt-3">
                  {reuplodaselectedPdf && (
                    <iframe
                      title="PDF Viewer"
                      style={iframeStyle}
                      src={reuplodaselectedPdf}
                    />
                  )}
                </div>
                <div
                  className={
                    selectedPdf !== null ? "col-md-6 mt-3" : "col-md-12 mt-3"
                  }
                  style={{ display: selectedPdf !== null ? "" : "none" }}
                >
                  <span className="mt-2 fs-4">Milestone</span>
                  {inputList.map((x, i) => (
                    <div className="box" key={i}>
                      <div className="d-flex justify-content-between">
                        <div className="d-flex">
                          {" "}
                          <p className="mt-2">{i + 1}</p>
                          <span className="mt-2">:</span>
                          <input
                            value={x.Milestone}
                            onChange={(e) => handleInputChanges(e, i)}
                            name="Milestone"
                            placeholder="Milestone Name"
                            className="ms-1 mt-1"
                            style={{
                              height: "38px",
                              width: "auto",
                              borderRadius: "6px",
                            }}
                          />
                        </div>
                        <div className="d-flex">
                          <label className="me-2 mt-2">Amount</label>
                          <TextField
                            style={{
                              border: "1px solid lightgray",
                              borderBottom: "0px !important",
                              outline: "none",
                              height: "34px",
                            }}
                            className="budgetinput form-control mt-1"
                            value={x.price}
                            onChange={(e) => handleInputChanges(e, i)}
                            name="price"
                            id="formatted-numberformat-input"
                            // placeholder="Project Budget"
                            InputProps={{
                              inputComponent: NumericFormatCustom,
                            }}
                            variant="standard"
                          />
                        </div>
                      </div>
                      <textarea
                        name="description"
                        className="mt-2 ms-3"
                        style={{
                          height: "100px",
                          width: "98%",
                          borderRadius: "6px",
                        }}
                        placeholder="Description"
                        value={x.description}
                        onChange={(e) => handleInputChanges(e, i)}
                      />
                      <div className="btn-box">
                        {inputList.length !== 1 && (
                          <button
                            className="mr10 btn detail-btn ms-3"
                            onClick={() => handleRemoveClick(i)}
                          >
                            Remove
                          </button>
                        )}
                        {inputList.length - 1 === i && (
                          <button
                            className="btn btn-cvault ms-2"
                            onClick={handleAddClick}
                          >
                            Add
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Modal>

      <Modal
        open={ownerinformation}
        onClose={() => setownerInformation(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...modelStyleowner, width: "40%" }}>
          {selectedOwner ? (
            <div>
              <div className="d-flex justify-content-between">
                <h5>Owner Information</h5>
                <IoMdClose
                  className="fs-5 cursor"
                  onClick={() => {
                    setownerInformation(false);
                  }}
                />
              </div>
              <div className="dropdown-divider"></div>

              <div className="">
                <div className="row d-flex">
                  <div className="col-md-3">
                    <b>Name</b>
                  </div>
                  <div className="col-md-1">
                    <b>:</b>
                  </div>
                  <div className="col-md-8">
                    {selectedOwner?.owner_details?.owner_name}
                  </div>
                </div>

                <div className="row d-flex mt-2">
                  <div className="col-md-3">
                    <b>Phone</b>
                  </div>
                  <div className="col-md-1">
                    <b>:</b>
                  </div>
                  <div className="col-md-8">
                    {selectedOwner?.owner_details?.contact_info}
                  </div>
                </div>
                <div className="row d-flex mt-2">
                  <div className="col-md-3">
                    <b>Email</b>
                  </div>
                  <div className="col-md-1">
                    <b>:</b>
                  </div>
                  <div className="col-md-8">
                    {selectedOwner?.owner_details?.email}
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </Box>
      </Modal>

      <Modal
        open={contractorInfo}
        onClose={() => setConTractorInfo(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...modelStyleowner, width: "40%" }}>
          {selectedContractor ? (
            <div>
              <div className="d-flex justify-content-between">
                <h5>Contractor Information</h5>
                <IoMdClose
                  className="fs-5 cursor"
                  onClick={() => {
                    setConTractorInfo(false);
                  }}
                />
              </div>
              <div className="dropdown-divider"></div>

              <div className="">
                <div className="row d-flex">
                  <div className="col-md-3">
                    <b>Name</b>
                  </div>
                  <div className="col-md-1">
                    <b>:</b>
                  </div>
                  <div className="col-md-8">
                    {selectedContractor?.contractor_details?.contractor_name}
                  </div>
                </div>

                <div className="row d-flex mt-2">
                  <div className="col-md-3">
                    <b>Phone</b>
                  </div>
                  <div className="col-md-1">
                    <b>:</b>
                  </div>
                  <div className="col-md-8">
                    {selectedContractor?.contractor_details?.contact_info}
                  </div>
                </div>
                <div className="row d-flex mt-2">
                  <div className="col-md-3">
                    <b>Email</b>
                  </div>
                  <div className="col-md-1">
                    <b>:</b>
                  </div>
                  <div className="col-md-8">
                    {selectedContractor?.contractor_details?.email}
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </Box>
      </Modal>

      <Drawer
        variant="temporary"
        anchor="right"
        open={viewInspectionReport}
        onClose={() => {
          setViewInspectorReport(false);
          setMileChat(false);
          setShowDocuments(null);
          setViewCR(false);
          setViewInsHistory(false);
          setExpanded({});
          setExpandInspection({});
          setFileError("");
        }}
        sx={{
          width: "50%",
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: "50%",
            boxSizing: "border-box",
          },
        }}
      >
        <Box
          sx={{
            padding: "10px",
          }}
        >
          {files.length !== 0 ? (
            <div>
              <div className="d-flex justify-content-between">
                <h5>View Inspection Report</h5>
                <IoMdClose
                  className="fs-5 cursor"
                  onClick={() => {
                    setMileChat(false);

                    setViewInspectorReport(false);
                    setShowDocuments(null);
                    setViewCR(false);
                    setViewInsHistory(false);
                    setExpanded({});
                    setExpandInspection({});
                    setFileError("");
                  }}
                />
              </div>
              <div className="dropdown-divider"></div>
              <div className="">
                <div className="mb-2">
                  <label
                    className="milestonechangeRequest"
                    style={{ width: "35%" }}
                  >
                    Milestone{" "}
                  </label>
                  <span className="text-center text-primary">
                    {" : "}
                    {inspectionReport.milestone_number +
                      ". " +
                      inspectionReport.milestone_name}
                  </span>
                </div>

                {inspectionReport?.compliance_comments && (
                  <div className="mb-2">
                    <label
                      className="milestonechangeRequest"
                      style={{ width: "35%" }}
                    >
                      Compliant Notes
                    </label>
                    <span className="text-center ">
                      {" : " + inspectionReport?.compliance_comments}
                    </span>
                  </div>
                )}
                {inspectionReport?.non_compliance_comments && (
                  <div className=" mb-2">
                    <label
                      className="milestonechangeRequest"
                      style={{ width: "35%" }}
                    >
                      Non-compliant Notes
                    </label>
                    <span className="text-center  ">
                      {" : " + inspectionReport?.non_compliance_comments}
                    </span>
                  </div>
                )}

                <div className="mb-2">
                  <label className="milestonechangeRequest">
                    Milestone Description{" "}
                  </label>
                  <span className=" ">
                    <div
                      style={{
                        marginTop: "10px",
                        overflowY: "auto",
                        overflowX: "hidden",
                        maxHeight: "300px",
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                        // fontFamily: "sans-serif",
                        height: "auto",
                        marginBottom: "0px",
                      }}
                    >
                      <div>{inspectionReport.milestone_description}</div>
                      {inspectionReport?.change_request?.length > 0 && (
                        <div
                          onClick={() => {
                            setViewCR(!viewCR);
                          }}
                          style={{ cursor: "pointer" }}
                          className="d-flex align-items-center mt-1"
                        >
                          <span
                            style={{
                              transition: "transform 0.3s ease",
                              fontSize: "10px",
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              xmlnsXlink="http://www.w3.org/1999/xlink"
                              viewBox="0 0 512 512"
                              width={15}
                              height={15}
                              style={{
                                enableBackground: "new 0 0 512 512",
                              }}
                              xmlSpace="preserve"
                            >
                              <g>
                                <path
                                  d="M420.608 311.463 512 259l-96.612-55.463L512 148.073 256 1.109 0 148.073l96.612 55.463L0 259l91.39 52.463L0 363.927 256 510.89l256-146.963-91.392-52.464zM80.29 148.073 256 47.201l175.71 100.871L256 248.943 80.29 148.073zm0 110.925 56.468-32.417L256 295.035l119.242-68.454 56.468 32.417L256 359.868 80.29 258.998zm0 104.929 51.246-29.419L256 405.96l124.464-71.452 51.246 29.419L256 464.798 80.29 363.927z"
                                  fill={"#000"}
                                />
                              </g>
                            </svg>
                          </span>
                          <span
                            className="ms-2 text-primary"
                            style={{
                              color: !viewCR ? "#0d6efd" : "lightgray",
                            }}
                          >
                            {!viewCR
                              ? "View Change Request History"
                              : "Close Change Request History"}
                          </span>
                        </div>
                      )}
                      {inspectionReport?.inspection_details === null ||
                        (viewCR && (
                          <div
                            style={{
                              borderLeft: "2px solid lightgray",
                              marginLeft: "7px",
                            }}
                          >
                            <div
                              style={{
                                marginLeft: viewCR ? "25px" : "0px",
                              }}
                            >
                              {inspectionReport?.change_request?.length > 0 &&
                                inspectionReport?.change_request.map(
                                  (request, index) => (
                                    <div
                                      key={index}
                                      style={{
                                        marginTop: "5px",
                                      }}
                                    >
                                      <strong>
                                        {request?.change_request_heading}
                                        {":"}
                                      </strong>
                                      <div>
                                        {"Initiated Date: " +
                                          request?.initiate_date}
                                      </div>
                                      <div>
                                        {
                                          request
                                            ?.change_request_description?.[0]
                                            ?.user_name
                                        }{" "}
                                        (
                                        {
                                          request
                                            ?.change_request_description?.[0]
                                            ?.user_role
                                        }
                                        ) initiated a change request
                                      </div>
                                      {request?.change_request_description?.map(
                                        (msg, msgIndex) => (
                                          <div>
                                            <div key={msgIndex}>
                                              <span>
                                                {msg?.user_name} (
                                                {msg?.user_role}):{" "}
                                                {msg?.message}
                                              </span>

                                              {msg?.files_path?.length > 0 && (
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                  }}
                                                >
                                                  <Tooltip
                                                    title={
                                                      !expanded[msgIndex]
                                                        ? "Click to expand files"
                                                        : "Click to collpase files"
                                                    }
                                                    placement="right"
                                                  >
                                                    <div
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      className="d-flex align-items-center"
                                                      onClick={() =>
                                                        toggleExpand(msgIndex)
                                                      }
                                                    >
                                                      <span
                                                        style={{
                                                          transition:
                                                            "transform 0.3s ease",

                                                          fontSize: "10px",
                                                        }}
                                                      >
                                                        <svg
                                                          xmlns="http://www.w3.org/2000/svg"
                                                          version="1.1"
                                                          xmlnsXlink="http://www.w3.org/1999/xlink"
                                                          viewBox="0 0 512 512"
                                                          width={15}
                                                          height={15}
                                                          style={{
                                                            marginBottom: "4px",
                                                            enableBackground:
                                                              "new 0 0 512 512",
                                                          }}
                                                          xmlSpace="preserve"
                                                        >
                                                          <g>
                                                            <path
                                                              d="M420.608 311.463 512 259l-96.612-55.463L512 148.073 256 1.109 0 148.073l96.612 55.463L0 259l91.39 52.463L0 363.927 256 510.89l256-146.963-91.392-52.464zM80.29 148.073 256 47.201l175.71 100.871L256 248.943 80.29 148.073zm0 110.925 56.468-32.417L256 295.035l119.242-68.454 56.468 32.417L256 359.868 80.29 258.998zm0 104.929 51.246-29.419L256 405.96l124.464-71.452 51.246 29.419L256 464.798 80.29 363.927z"
                                                              fill={"#000"}
                                                            />
                                                          </g>
                                                        </svg>
                                                        <span
                                                          className="text-primary"
                                                          style={{
                                                            fontSize: "13px",
                                                            marginLeft: "5px",
                                                          }}
                                                        >
                                                          {msg?.files_path
                                                            ?.length === 1
                                                            ? "1 document"
                                                            : `${msg?.files_path?.length} documents`}
                                                        </span>
                                                      </span>
                                                    </div>
                                                  </Tooltip>
                                                </div>
                                              )}
                                            </div>
                                            <Collapse
                                              in={expanded[msgIndex]}
                                              style={{
                                                marginLeft: "5px",
                                              }}
                                            >
                                              <ol
                                                style={{
                                                  marginBottom: "0rem",
                                                  paddingLeft: "10px",
                                                }}
                                              >
                                                {msg?.files_path?.map(
                                                  (file, fileIndex) => (
                                                    <li key={fileIndex}>
                                                      <span
                                                        style={{
                                                          cursor: "pointer",
                                                          textDecoration:
                                                            "underline",
                                                        }}
                                                        onClick={() => {
                                                          viewFiles(file, true);
                                                        }}
                                                      >
                                                        <i>
                                                          {file
                                                            .split("/")
                                                            .pop()}
                                                        </i>
                                                      </span>
                                                    </li>
                                                  )
                                                )}
                                              </ol>
                                            </Collapse>
                                          </div>
                                        )
                                      )}

                                      {request?.revised_amount !== null && (
                                        <div>
                                          Amount:{" "}
                                          {request?.revised_amount
                                            .replace("$$", "$")
                                            .replace(".00", "")}
                                        </div>
                                      )}
                                      <div>
                                        {request?.accepted_date
                                          ? "Accepted date: "
                                          : "Denied date: "}
                                        {request?.accepted_date ||
                                          request?.denied_date}
                                      </div>
                                      <div>
                                        {request?.accepted_denied_by}{" "}
                                        <strong>
                                          {request?.accepted_date
                                            ? "accepted"
                                            : "denied"}
                                        </strong>{" "}
                                        the change request
                                      </div>
                                    </div>
                                  )
                                )}
                            </div>
                          </div>
                        ))}

                      {inspectionReport?.inspection_details?.length > 0 && (
                        <div
                          onClick={() => {
                            setViewInsHistory(!viewInsHistory);
                          }}
                          style={{ cursor: "pointer" }}
                          className="d-flex align-items-center mt-1"
                        >
                          <span
                            style={{
                              transition: "transform 0.3s ease",
                              fontSize: "10px",
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              xmlnsXlink="http://www.w3.org/1999/xlink"
                              viewBox="0 0 512 512"
                              width={15}
                              height={15}
                              style={{
                                enableBackground: "new 0 0 512 512",
                              }}
                              xmlSpace="preserve"
                            >
                              <g>
                                <path
                                  d="M420.608 311.463 512 259l-96.612-55.463L512 148.073 256 1.109 0 148.073l96.612 55.463L0 259l91.39 52.463L0 363.927 256 510.89l256-146.963-91.392-52.464zM80.29 148.073 256 47.201l175.71 100.871L256 248.943 80.29 148.073zm0 110.925 56.468-32.417L256 295.035l119.242-68.454 56.468 32.417L256 359.868 80.29 258.998zm0 104.929 51.246-29.419L256 405.96l124.464-71.452 51.246 29.419L256 464.798 80.29 363.927z"
                                  fill={"#000"}
                                />
                              </g>
                            </svg>
                          </span>
                          <span
                            className="ms-2 text-primary"
                            style={{
                              color: !viewInsHistory ? "#0d6efd" : "lightgray",
                            }}
                          >
                            {!viewInsHistory
                              ? "View Inspection History"
                              : "Close Inspection History"}
                          </span>
                        </div>
                      )}

                      {viewInsHistory &&
                        inspectionReport?.inspection_details?.length > 0 && (
                          <div
                            style={{
                              borderLeft: "2px solid lightgray",
                              marginLeft: "7px",
                            }}
                          >
                            <div
                              style={{
                                marginLeft: viewInsHistory ? "25px" : "0px",
                              }}
                            >
                              {inspectionReport?.inspection_details?.map(
                                (inspection, index) => (
                                  <div key={index}>
                                    <strong>
                                      Inspection {inspection.inspection_number}:
                                    </strong>
                                    {inspection?.requested_date && (
                                      <div>
                                        Requested date:{" "}
                                        {inspection.requested_date}{" "}
                                      </div>
                                    )}

                                    {inspection?.submission_date && (
                                      <div>
                                        Submission date:{" "}
                                        {inspection.submission_date}{" "}
                                      </div>
                                    )}
                                    <div>
                                      Inspection Status:{" "}
                                      {inspection?.compliance_status === "meets"
                                        ? "Compliant"
                                        : "Non-Compliant"}{" "}
                                    </div>
                                    {inspection?.compliance_comments && (
                                      <div>
                                        Compliance Notes:{" "}
                                        {inspection.compliance_comments}{" "}
                                      </div>
                                    )}
                                    {inspection?.non_compliance_comments && (
                                      <div>
                                        Non-compliance Notes:{" "}
                                        {inspection.non_compliance_comments}{" "}
                                      </div>
                                    )}
                                    {inspection?.inspector && (
                                      <div>
                                        Inspector Name: {inspection.inspector}{" "}
                                      </div>
                                    )}

                                    {inspection?.file_data?.length > 0 && (
                                      <div>
                                        <Tooltip
                                          title={
                                            !expandInspection[index]
                                              ? "Click to expand files"
                                              : "Click to collpase files"
                                          }
                                          placement="right"
                                        >
                                          <div
                                            style={{
                                              cursor: "pointer",
                                            }}
                                            className="d-flex align-items-center"
                                            onClick={() =>
                                              toggleExpandInspection(index)
                                            }
                                          >
                                            <span
                                              style={{
                                                transition:
                                                  "transform 0.3s ease",

                                                fontSize: "10px",
                                              }}
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                version="1.1"
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                                viewBox="0 0 512 512"
                                                width={15}
                                                height={15}
                                                style={{
                                                  marginBottom: "4px",
                                                  enableBackground:
                                                    "new 0 0 512 512",
                                                }}
                                                xmlSpace="preserve"
                                              >
                                                <g>
                                                  <path
                                                    d="M420.608 311.463 512 259l-96.612-55.463L512 148.073 256 1.109 0 148.073l96.612 55.463L0 259l91.39 52.463L0 363.927 256 510.89l256-146.963-91.392-52.464zM80.29 148.073 256 47.201l175.71 100.871L256 248.943 80.29 148.073zm0 110.925 56.468-32.417L256 295.035l119.242-68.454 56.468 32.417L256 359.868 80.29 258.998zm0 104.929 51.246-29.419L256 405.96l124.464-71.452 51.246 29.419L256 464.798 80.29 363.927z"
                                                    fill={"#000"}
                                                  />
                                                </g>
                                              </svg>
                                              <span
                                                className="text-primary"
                                                style={{
                                                  fontSize: "13px",
                                                  marginLeft: "5px",
                                                }}
                                              >
                                                {inspection.file_data
                                                  ?.length === 1
                                                  ? "1 document"
                                                  : `${inspection.file_data?.length} documents`}
                                              </span>
                                            </span>
                                          </div>
                                        </Tooltip>

                                        <Collapse
                                          in={expandInspection[index]}
                                          style={{
                                            marginLeft: "5px",
                                          }}
                                        >
                                          <ol
                                            style={{
                                              marginBottom: "0rem",
                                              paddingLeft: "10px",
                                              // fontSize: "13px",
                                            }}
                                          >
                                            {inspection.file_data.map(
                                              (file, fileIndex) => (
                                                <li
                                                  key={fileIndex}
                                                  style={{
                                                    marginTop: "5px",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      textDecoration:
                                                        "underline",
                                                      cursor: "pointer",
                                                    }}
                                                    onClick={() =>
                                                      viewFiles(file, true)
                                                    }
                                                  >
                                                    <i>
                                                      {file.split("/").pop()}
                                                    </i>
                                                  </span>
                                                </li>
                                              )
                                            )}
                                          </ol>
                                        </Collapse>
                                      </div>
                                    )}
                                  </div>
                                )
                              )}
                            </div>
                          </div>
                        )}
                    </div>
                  </span>
                </div>

                {files.length > 0 && (
                  <div className="">
                    <label className="milestonechangeRequest">
                      Attached Inspection Reports
                    </label>
                  </div>
                )}
                <div
                  className="grid-container"
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fill, minmax(90px, 1fr))",
                    gap: "0px",
                    padding: "0px 12px",
                    overflowX: "auto",
                  }}
                >
                  {files?.map((item, index) => (
                    <div
                      key={index}
                      className="preview-item group relative text-sm text-token-text-primary view_files"
                      style={{
                        display: "grid",
                        alignItems: "center",
                        justifyItems: "center",
                        background: "#fff",
                        borderRadius: "2px",
                      }}
                    >
                      <div className="relative overflow-hidden border-token-border-light bg-token-main-surface-primary rounded-xl view_files">
                        <div className="text-center">
                          {(item?.type?.includes("image") ||
                            (typeof item === "string" &&
                              /\.(jpg|jpeg|png|gif|bmp|webp|svg|tiff|ico)$/i.test(
                                item
                              ))) && (
                            <Tooltip
                              placement="top"
                              title="click to view image"
                            >
                              <div
                                style={{
                                  color: "gray",
                                  cursor: "pointer",
                                }}
                                className="gap-2"
                                onClick={() => {
                                  if (item?.type) {
                                    setContractDocuments(true);
                                    setSelectedContractDoc(
                                      URL.createObjectURL(item.blob)
                                    );
                                  } else {
                                    viewFiles(item, true);
                                  }
                                }}
                              >
                                <TextSnippetIcon
                                  style={{
                                    width: "25px",
                                    height: "25px",
                                    color: "rgb(128 175 215)",
                                    opacity: "0.9",
                                  }}
                                  className="relative h-10 w-10 shrink-0 overflow-hidden rounded-lg"
                                />
                              </div>
                            </Tooltip>
                          )}
                          {(item?.type === "video" ||
                            item?.type === "video/mp4" ||
                            (typeof item === "string" &&
                              /\.(mp4|mov|wmv|avi|flv|mkv|webm|mpeg|mpg)$/i.test(
                                item
                              ))) && (
                            <div
                              style={{
                                color: "gray",
                                cursor: "pointer",
                              }}
                              className="gap-2"
                              onClick={() => {
                                viewFiles(item, true);
                              }}
                            >
                              <TextSnippetIcon
                                style={{
                                  width: "25px",
                                  height: "25px",
                                  color: "rgb(128 175 215)",
                                  opacity: "0.9",
                                }}
                              />
                            </div>
                          )}

                          {(item?.type?.includes("pdf") ||
                            (typeof item === "string" &&
                              item.includes("pdf"))) && (
                            <Tooltip
                              title={`Click to view pdf`}
                              placement="top"
                            >
                              <div
                                style={{
                                  color: "gray",
                                  cursor: "pointer",
                                }}
                                className="gap-2"
                                onClick={() => {
                                  if (item?.type) {
                                    setContractDocuments(true);
                                    setSelectedContractDoc(
                                      URL.createObjectURL(item.blob)
                                    );
                                  } else {
                                    viewFiles(item, true);
                                  }
                                }}
                              >
                                <TextSnippetIcon
                                  style={{
                                    width: "25px",
                                    height: "25px",
                                    color: "rgb(128 175 215)",
                                    opacity: "0.9",
                                  }}
                                />
                              </div>
                            </Tooltip>
                          )}

                          {(item?.type === "text" ||
                            (typeof item === "string" &&
                              /\.(txt)$/i.test(item))) && (
                            <Tooltip
                              title={`Click to view text`}
                              placement="top"
                            >
                              <div
                                style={{
                                  color: "gray",
                                  cursor: "pointer",
                                }}
                                className="gap-2"
                                onClick={() => {
                                  if (item?.type) {
                                    setContractDocuments(true);
                                    setSelectedContractDoc(
                                      URL.createObjectURL(item.blob)
                                    );
                                  } else {
                                    viewFiles(item, true);
                                  }
                                }}
                              >
                                <TextSnippetIcon
                                  style={{
                                    width: "25px",
                                    height: "25px",
                                    color: "rgb(128 175 215)",
                                    opacity: "0.9",
                                  }}
                                />
                              </div>
                            </Tooltip>
                          )}

                          {(item?.type === "other" ||
                            /\.(?!jpg|jpeg|png|gif|bmp|webp|svg|tiff|ico|pdf|txt|mp4|mov|wmv|avi|flv|mkv|webm|mpeg|mpg)([a-z0-9]+)$/i.test(
                              item
                            )) &&
                            typeof item === "string" && (
                              <Tooltip title={`Click to view`} placement="top">
                                <div
                                  style={{
                                    color: "gray",
                                    cursor: "pointer",
                                  }}
                                  className="gap-2"
                                  onClick={() => {
                                    if (item?.type) {
                                      setContractDocuments(true);
                                      setSelectedContractDoc(
                                        URL.createObjectURL(item.blob)
                                      );
                                    } else {
                                      viewFiles(item, true);
                                    }
                                  }}
                                >
                                  <TextSnippetIcon
                                    style={{
                                      width: "25px",
                                      height: "25px",
                                      color: "rgb(128 175 215)",
                                      opacity: "0.9",
                                    }}
                                  />
                                </div>
                              </Tooltip>
                            )}

                          <div
                            style={{
                              fontSize: "13px",
                              marginRight: "3px",
                              marginLeft: "2px",
                              marginTop: "10px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              viewFiles(item, true);
                            }}
                          >
                            {(() => {
                              const fileName = (item.name || item)
                                .split("/")
                                .pop(); // Extract filename from path
                              if (fileName.length > 9) {
                                return (
                                  fileName.replace(/ /g, "").slice(0, 5) +
                                  "..." +
                                  fileName.replace(/ /g, "").slice(-4)
                                );
                              }
                              return fileName.replace(/ /g, "");
                            })()}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                {isLoader && (
                  <div className="mt-2">
                    <div
                      className="text-center mb-3"
                      style={{ fontSize: "13px", color: "#F5AE41" }}
                    >
                      Fetching document from cloud storage. Please wait...
                    </div>

                    <BarLoader
                      color="#F5AE41"
                      width={"80%"}
                      height={5}
                      className="loader"
                      loading={isLoader}
                    />
                  </div>
                )}
                {showDocuments && (
                  <div
                    style={{
                      padding: "0px 10px",
                      width: "100%",
                      height: "auto",
                    }}
                  >
                    <label className="mb-2" style={{ fontSize: "14px" }}>
                      Selected Document :{" "}
                      <span className="text-primary">
                        {showDocuments.file_name}
                      </span>
                    </label>

                    {typeof showDocuments.base64_content === "string" &&
                      /\.(jpg|jpeg|png|gif|bmp|webp|svg|tiff|ico)$/i.test(
                        showDocuments.file_name
                      ) && (
                        <iframe
                          style={{ width: "100%", height: "60vh" }}
                          src={showDocuments.base64_content}
                        ></iframe>
                      )}
                    {typeof showDocuments.base64_content === "string" &&
                      /\.(pdf)$/i.test(showDocuments.file_name) && (
                        <iframe
                          style={{ width: "100%", height: "60vh" }}
                          src={showDocuments.base64_content}
                        ></iframe>
                      )}

                    {typeof showDocuments.base64_content === "string" &&
                      /\.(mp4|mov|wmv|avi|flv|mkv|webm|mpeg|mpg)$/i.test(
                        showDocuments.file_name
                      ) && (
                        <video
                          style={{ width: "100%", height: "60vh" }}
                          controls
                          src={showDocuments.base64_content}
                        ></video>
                      )}

                    {typeof showDocuments.base64_content === "string" &&
                      /\.(txt)$/i.test(showDocuments.file_name) && (
                        <iframe
                          style={{ width: "100%", height: "60vh" }}
                          src={showDocuments.base64_content}
                        ></iframe>
                      )}
                  </div>
                )}
                {fileError !== "" && (
                  <div className="text-danger text-center">{fileError}</div>
                )}
              </div>
            </div>
          ) : null}
        </Box>
      </Drawer>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "center", // Center vertically
          horizontal: "left", // Align to the right side
        }}
        transformOrigin={{
          vertical: "center", // Center vertically
          horizontal: "right", // Align to the left side
        }}
        style={{ borderRadius: "5px", marginLeft: "-1%" }}
      >
        <Typography style={popoverStyle}>
          <div className="text-center  d-flex justify-content-center h-100 align-items-center ">
            <div>
              <p className="fw-bold fs-6">Project Recap</p>
              <span className="admininspection">
                Not Started
                <span style={{ marginLeft: "60px" }} />
                {count?.["Not Started"] || 0}
              </span>
              <span className="admininspection">
                In Progress
                <span style={{ marginLeft: "60px" }} />
                {count?.["In Progress"] || 0}
              </span>
              <span className="admininspection">
                Inspection Request
                <span style={{ marginLeft: "11px" }} />
                {count?.["Inspection Request"] || 0}
              </span>
              <span className="admininspection">
                Completed
                <span style={{ marginLeft: "64px" }} />
                {count?.["Completed"] || 0}
              </span>
            </div>
          </div>
        </Typography>
      </Popover>
      <style>
        {`
        //   .container { text-align: center; }
          .file-upload { margin-bottom: 20px; }
          .upload-btn { padding: 10px 20px; background: #007bff; color: white; cursor: pointer; border-radius: 5px; }
          .preview-container { display: flex; flex-wrap: wrap; gap: 10px; }
          .preview-item { position: relative; text-align: center;margin-top: 5px }
          .file-name { font-size: 14px; margin-bottom: 5px; color: #333; }
          .preview-img, .preview-video, .preview-pdf { width: 60px; height: 60px; object-fit: fill; border-radius: 5px; }
          .preview-imgs, .preview-videos, .preview-pdfs { width: 100%; height: 100px; object-fit: cover; border-radius: 5px; }
          .delete-btn { position: absolute; top: 0px; right: 0px; background: gray; color: white; border: none; cursor: pointer; border-radius: 50%;font-size:12px  }
        `}
      </style>

      {/* Modal for File View */}

      <Modal
        open={ContractDocuments}
        onClose={() => {
          setContractDocuments(false);
          setSelectedContractDoc(null); // Reset selected document on close
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            borderRadius: "5px",
            boxShadow: 24,
            width: "70%",
            height: "90%",
            overflowY: "auto",
          }}
        >
          <div>
            {/* Modal Header */}
            <div
              style={{
                position: "sticky",
                top: "0",
                zIndex: 2,
                backgroundColor: "white",
                borderBottom: "1px solid lightgray",
              }}
              className="d-flex justify-content-between ps-4 pe-2 pt-2"
            >
              <h5>Uploaded Document</h5>
              <IoIosClose
                className="fs-1 cursor"
                onClick={() => {
                  setContractDocuments(false);
                  setSelectedContractDoc(null);
                }}
              />
            </div>

            <div style={{ padding: "0px 16px" }}>
              {selectedContractDoc && (
                <>
                  {" "}
                  <iframe
                    title="PDF Viewer"
                    style={{
                      width: "100%",
                      height: "85vh",
                      border: "none",
                      objectFit: "contain",
                    }}
                    src={selectedContractDoc}
                  />
                </>
              )}
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default InspectorHome;
